if (function(e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == typeof exports ? require("jquery") : jQuery)
  }(function(e) {
    function t(e) {
      return a.raw ? e : encodeURIComponent(e)
    }

    function o(e) {
      return a.raw ? e : decodeURIComponent(e)
    }

    function n(e) {
      return t(a.json ? JSON.stringify(e) : String(e))
    }

    function i(e) {
      0 === e.indexOf('"') && (e = e.slice(1, -1).replace(/\\"/g, '"').replace(/\\\\/g, "\\"));
      try {
        return e = decodeURIComponent(e.replace(s, " ")), a.json ? JSON.parse(e) : e
      } catch (t) {}
    }

    function r(t, o) {
      var n = a.raw ? t : i(t);
      return e.isFunction(o) ? o(n) : n
    }
    var s = /\+/g,
      a = e.cookie = function(i, s, l) {
        if (arguments.length > 1 && !e.isFunction(s)) {
          if (l = e.extend({}, a.defaults, l), "number" == typeof l.expires) {
            var c = l.expires,
              u = l.expires = new Date;
            u.setTime(+u + 864e5 * c)
          }
          return document.cookie = [t(i), "=", n(s), l.expires ? "; expires=" + l.expires.toUTCString() : "", l.path ? "; path=" + l.path : "", l.domain ? "; domain=" + l.domain : "", l.secure ? "; secure" : ""].join("")
        }
        for (var d = i ? void 0 : {}, p = document.cookie ? document.cookie.split("; ") : [], m = 0, f = p.length; m < f; m++) {
          var h = p[m].split("="),
            y = o(h.shift()),
            g = h.join("=");
          if (i && i === y) {
            d = r(g, s);
            break
          }
          i || void 0 === (g = r(g)) || (d[y] = g)
        }
        return d
      };
    a.defaults = {}, e.removeCookie = function(t, o) {
      return void 0 !== e.cookie(t) && (e.cookie(t, "", e.extend({}, o, {
        expires: -1
      })), !e.cookie(t))
    }
  }), "undefined" == typeof Currency) var Currency = {};
Currency.cookie = {
    configuration: {
      expires: 365,
      path: "/",
      domain: window.location.hostname
    },
    name: "currency",
    write: function(e) {
      jQuery.cookie(this.name, e, this.configuration)
    },
    read: function() {
      return jQuery.cookie(this.name)
    },
    destroy: function() {
      jQuery.cookie(this.name, null, this.configuration)
    }
  }, Currency.moneyFormats = {
    USD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} USD"
    },
    EUR: {
      money_format: "&euro;{{amount}}",
      money_with_currency_format: "&euro;{{amount}} EUR"
    },
    GBP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} GBP"
    },
    CAD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} CAD"
    },
    ALL: {
      money_format: "Lek {{amount}}",
      money_with_currency_format: "Lek {{amount}} ALL"
    },
    DZD: {
      money_format: "DA {{amount}}",
      money_with_currency_format: "DA {{amount}} DZD"
    },
    AOA: {
      money_format: "Kz{{amount}}",
      money_with_currency_format: "Kz{{amount}} AOA"
    },
    ARS: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} ARS"
    },
    AMD: {
      money_format: "{{amount}} AMD",
      money_with_currency_format: "{{amount}} AMD"
    },
    AWG: {
      money_format: "Afl{{amount}}",
      money_with_currency_format: "Afl{{amount}} AWG"
    },
    AUD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} AUD"
    },
    BBD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} Bds"
    },
    AZN: {
      money_format: "m.{{amount}}",
      money_with_currency_format: "m.{{amount}} AZN"
    },
    BDT: {
      money_format: "Tk {{amount}}",
      money_with_currency_format: "Tk {{amount}} BDT"
    },
    BSD: {
      money_format: "BS${{amount}}",
      money_with_currency_format: "BS${{amount}} BSD"
    },
    BHD: {
      money_format: "{{amount}}0 BD",
      money_with_currency_format: "{{amount}}0 BHD"
    },
    BYR: {
      money_format: "Br {{amount}}",
      money_with_currency_format: "Br {{amount}} BYR"
    },
    BZD: {
      money_format: "BZ${{amount}}",
      money_with_currency_format: "BZ${{amount}} BZD"
    },
    BTN: {
      money_format: "Nu {{amount}}",
      money_with_currency_format: "Nu {{amount}} BTN"
    },
    BAM: {
      money_format: "KM {{amount_with_comma_separator}}",
      money_with_currency_format: "KM {{amount_with_comma_separator}} BAM"
    },
    BRL: {
      money_format: "R$ {{amount_with_comma_separator}}",
      money_with_currency_format: "R$ {{amount_with_comma_separator}} BRL"
    },
    BOB: {
      money_format: "Bs{{amount_with_comma_separator}}",
      money_with_currency_format: "Bs{{amount_with_comma_separator}} BOB"
    },
    BWP: {
      money_format: "P{{amount}}",
      money_with_currency_format: "P{{amount}} BWP"
    },
    BND: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} BND"
    },
    BGN: {
      money_format: "{{amount}} Ð»Ð²",
      money_with_currency_format: "{{amount}} Ð»Ð² BGN"
    },
    MMK: {
      money_format: "K{{amount}}",
      money_with_currency_format: "K{{amount}} MMK"
    },
    KHR: {
      money_format: "KHR{{amount}}",
      money_with_currency_format: "KHR{{amount}}"
    },
    KYD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} KYD"
    },
    XAF: {
      money_format: "FCFA{{amount}}",
      money_with_currency_format: "FCFA{{amount}} XAF"
    },
    CLP: {
      money_format: "${{amount_no_decimals}}",
      money_with_currency_format: "${{amount_no_decimals}} CLP"
    },
    CNY: {
      money_format: "&#165;{{amount}}",
      money_with_currency_format: "&#165;{{amount}} CNY"
    },
    COP: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} COP"
    },
    CRC: {
      money_format: "&#8353; {{amount_with_comma_separator}}",
      money_with_currency_format: "&#8353; {{amount_with_comma_separator}} CRC"
    },
    HRK: {
      money_format: "{{amount_with_comma_separator}} kn",
      money_with_currency_format: "{{amount_with_comma_separator}} kn HRK"
    },
    CZK: {
      money_format: "{{amount_with_comma_separator}} K&#269;",
      money_with_currency_format: "{{amount_with_comma_separator}} K&#269;"
    },
    DKK: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "kr.{{amount_with_comma_separator}}"
    },
    DOP: {
      money_format: "RD$ {{amount}}",
      money_with_currency_format: "RD$ {{amount}}"
    },
    XCD: {
      money_format: "${{amount}}",
      money_with_currency_format: "EC${{amount}}"
    },
    EGP: {
      money_format: "LE {{amount}}",
      money_with_currency_format: "LE {{amount}} EGP"
    },
    ETB: {
      money_format: "Br{{amount}}",
      money_with_currency_format: "Br{{amount}} ETB"
    },
    XPF: {
      money_format: "{{amount_no_decimals_with_comma_separator}} XPF",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} XPF"
    },
    FJD: {
      money_format: "${{amount}}",
      money_with_currency_format: "FJ${{amount}}"
    },
    GMD: {
      money_format: "D {{amount}}",
      money_with_currency_format: "D {{amount}} GMD"
    },
    GHS: {
      money_format: "GH&#8373;{{amount}}",
      money_with_currency_format: "GH&#8373;{{amount}}"
    },
    GTQ: {
      money_format: "Q{{amount}}",
      money_with_currency_format: "{{amount}} GTQ"
    },
    GYD: {
      money_format: "G${{amount}}",
      money_with_currency_format: "${{amount}} GYD"
    },
    GEL: {
      money_format: "{{amount}} GEL",
      money_with_currency_format: "{{amount}} GEL"
    },
    HNL: {
      money_format: "L {{amount}}",
      money_with_currency_format: "L {{amount}} HNL"
    },
    HKD: {
      money_format: "${{amount}}",
      money_with_currency_format: "HK${{amount}}"
    },
    HUF: {
      money_format: "{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} Ft"
    },
    ISK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr ISK"
    },
    INR: {
      money_format: "Rs. {{amount}}",
      money_with_currency_format: "Rs. {{amount}}"
    },
    IDR: {
      money_format: "{{amount_with_comma_separator}}",
      money_with_currency_format: "Rp {{amount_with_comma_separator}}"
    },
    ILS: {
      money_format: "{{amount}} NIS",
      money_with_currency_format: "{{amount}} NIS"
    },
    JMD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} JMD"
    },
    JPY: {
      money_format: "&#165;{{amount_no_decimals}}",
      money_with_currency_format: "&#165;{{amount_no_decimals}} JPY"
    },
    JEP: {
      money_format: "&pound;{{amount}}",
      money_with_currency_format: "&pound;{{amount}} JEP"
    },
    JOD: {
      money_format: "{{amount}}0 JD",
      money_with_currency_format: "{{amount}}0 JOD"
    },
    KZT: {
      money_format: "{{amount}} KZT",
      money_with_currency_format: "{{amount}} KZT"
    },
    KES: {
      money_format: "KSh{{amount}}",
      money_with_currency_format: "KSh{{amount}}"
    },
    KWD: {
      money_format: "{{amount}}0 KD",
      money_with_currency_format: "{{amount}}0 KWD"
    },
    KGS: {
      money_format: "Ð»Ð²{{amount}}",
      money_with_currency_format: "Ð»Ð²{{amount}}"
    },
    LVL: {
      money_format: "Ls {{amount}}",
      money_with_currency_format: "Ls {{amount}} LVL"
    },
    LBP: {
      money_format: "L&pound;{{amount}}",
      money_with_currency_format: "L&pound;{{amount}} LBP"
    },
    LTL: {
      money_format: "{{amount}} Lt",
      money_with_currency_format: "{{amount}} Lt"
    },
    MGA: {
      money_format: "Ar {{amount}}",
      money_with_currency_format: "Ar {{amount}} MGA"
    },
    MKD: {
      money_format: "Ð´ÐµÐ½ {{amount}}",
      money_with_currency_format: "Ð´ÐµÐ½ {{amount}} MKD"
    },
    MOP: {
      money_format: "MOP${{amount}}",
      money_with_currency_format: "MOP${{amount}}"
    },
    MVR: {
      money_format: "Rf{{amount}}",
      money_with_currency_format: "Rf{{amount}} MRf"
    },
    MXN: {
      money_format: "$ {{amount}}",
      money_with_currency_format: "$ {{amount}} MXN"
    },
    MYR: {
      money_format: "RM{{amount}} MYR",
      money_with_currency_format: "RM{{amount}} MYR"
    },
    MUR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} MUR"
    },
    MDL: {
      money_format: "{{amount}} MDL",
      money_with_currency_format: "{{amount}} MDL"
    },
    MAD: {
      money_format: "{{amount}} dh",
      money_with_currency_format: "Dh {{amount}} MAD"
    },
    MNT: {
      money_format: "{{amount_no_decimals}} &#8366",
      money_with_currency_format: "{{amount_no_decimals}} MNT"
    },
    MZN: {
      money_format: "{{amount}} Mt",
      money_with_currency_format: "Mt {{amount}} MZN"
    },
    NAD: {
      money_format: "N${{amount}}",
      money_with_currency_format: "N${{amount}} NAD"
    },
    NPR: {
      money_format: "Rs{{amount}}",
      money_with_currency_format: "Rs{{amount}} NPR"
    },
    ANG: {
      money_format: "&fnof;{{amount}}",
      money_with_currency_format: "{{amount}} NA&fnof;"
    },
    NZD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} NZD"
    },
    NIO: {
      money_format: "C${{amount}}",
      money_with_currency_format: "C${{amount}} NIO"
    },
    NGN: {
      money_format: "&#8358;{{amount}}",
      money_with_currency_format: "&#8358;{{amount}} NGN"
    },
    NOK: {
      money_format: "kr {{amount_with_comma_separator}}",
      money_with_currency_format: "kr {{amount_with_comma_separator}} NOK"
    },
    OMR: {
      money_format: "{{amount_with_comma_separator}} OMR",
      money_with_currency_format: "{{amount_with_comma_separator}} OMR"
    },
    PKR: {
      money_format: "Rs.{{amount}}",
      money_with_currency_format: "Rs.{{amount}} PKR"
    },
    PGK: {
      money_format: "K {{amount}}",
      money_with_currency_format: "K {{amount}} PGK"
    },
    PYG: {
      money_format: "Gs. {{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "Gs. {{amount_no_decimals_with_comma_separator}} PYG"
    },
    PEN: {
      money_format: "S/. {{amount}}",
      money_with_currency_format: "S/. {{amount}} PEN"
    },
    PHP: {
      money_format: "&#8369;{{amount}}",
      money_with_currency_format: "&#8369;{{amount}} PHP"
    },
    PLN: {
      money_format: "{{amount_with_comma_separator}} zl",
      money_with_currency_format: "{{amount_with_comma_separator}} zl PLN"
    },
    QAR: {
      money_format: "QAR {{amount_with_comma_separator}}",
      money_with_currency_format: "QAR {{amount_with_comma_separator}}"
    },
    RON: {
      money_format: "{{amount_with_comma_separator}} lei",
      money_with_currency_format: "{{amount_with_comma_separator}} lei RON"
    },
    RUB: {
      money_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}}",
      money_with_currency_format: "&#1088;&#1091;&#1073;{{amount_with_comma_separator}} RUB"
    },
    RWF: {
      money_format: "{{amount_no_decimals}} RF",
      money_with_currency_format: "{{amount_no_decimals}} RWF"
    },
    WST: {
      money_format: "WS$ {{amount}}",
      money_with_currency_format: "WS$ {{amount}} WST"
    },
    SAR: {
      money_format: "{{amount}} SR",
      money_with_currency_format: "{{amount}} SAR"
    },
    STD: {
      money_format: "Db {{amount}}",
      money_with_currency_format: "Db {{amount}} STD"
    },
    RSD: {
      money_format: "{{amount}} RSD",
      money_with_currency_format: "{{amount}} RSD"
    },
    SCR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} SCR"
    },
    SGD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} SGD"
    },
    SYP: {
      money_format: "S&pound;{{amount}}",
      money_with_currency_format: "S&pound;{{amount}} SYP"
    },
    ZAR: {
      money_format: "R {{amount}}",
      money_with_currency_format: "R {{amount}} ZAR"
    },
    KRW: {
      money_format: "&#8361;{{amount_no_decimals}}",
      money_with_currency_format: "&#8361;{{amount_no_decimals}} KRW"
    },
    LKR: {
      money_format: "Rs {{amount}}",
      money_with_currency_format: "Rs {{amount}} LKR"
    },
    SEK: {
      money_format: "{{amount_no_decimals}} kr",
      money_with_currency_format: "{{amount_no_decimals}} kr SEK"
    },
    CHF: {
      money_format: "{{amount}} CHF",
      money_with_currency_format: "{{amount}} CHF"
    },
    TWD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TWD"
    },
    THB: {
      money_format: "{{amount}} &#xe3f;",
      money_with_currency_format: "{{amount}} &#xe3f; THB"
    },
    TZS: {
      money_format: "{{amount}} TZS",
      money_with_currency_format: "{{amount}} TZS"
    },
    TTD: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}} TTD"
    },
    TND: {
      money_format: "{{amount}}",
      money_with_currency_format: "{{amount}} DT"
    },
    TRY: {
      money_format: "{{amount}}TL",
      money_with_currency_format: "{{amount}}TL"
    },
    UGX: {
      money_format: "Ush {{amount_no_decimals}}",
      money_with_currency_format: "Ush {{amount_no_decimals}} UGX"
    },
    UAH: {
      money_format: "â‚´{{amount}}",
      money_with_currency_format: "â‚´{{amount}} UAH"
    },
    AED: {
      money_format: "Dhs. {{amount}}",
      money_with_currency_format: "Dhs. {{amount}} AED"
    },
    UYU: {
      money_format: "${{amount_with_comma_separator}}",
      money_with_currency_format: "${{amount_with_comma_separator}} UYU"
    },
    VUV: {
      money_format: "${{amount}}",
      money_with_currency_format: "${{amount}}VT"
    },
    VEF: {
      money_format: "Bs. {{amount_with_comma_separator}}",
      money_with_currency_format: "Bs. {{amount_with_comma_separator}} VEF"
    },
    VND: {
      money_format: "{{amount_no_decimals_with_comma_separator}}&#8363;",
      money_with_currency_format: "{{amount_no_decimals_with_comma_separator}} VND"
    },
    XBT: {
      money_format: "{{amount_no_decimals}} BTC",
      money_with_currency_format: "{{amount_no_decimals}} BTC"
    },
    XOF: {
      money_format: "CFA{{amount}}",
      money_with_currency_format: "CFA{{amount}} XOF"
    },
    ZMW: {
      money_format: "K{{amount_no_decimals_with_comma_separator}}",
      money_with_currency_format: "ZMW{{amount_no_decimals_with_comma_separator}}"
    }
  }, Currency.currentCurrency = "", Currency.format = "money_format", Currency.convertAll = function(e, t, o, n) {
    t = t || $(".currency-selector__select").val(), jQuery(o || "[data-money-convertible]").each(function() {
      var o = $(this);
      o.attr("data-currency-" + e) || o.attr("data-currency-" + e, o.html());
      var i = o.attr("data-currency-" + e);
      if (o.attr("data-currency") !== t) {
        if (o.attr("data-currency-" + t)) o.html(o.attr("data-currency-" + t));
        else {
          var r = 0,
            s = Currency.moneyFormats[e][n || Currency.format] || "{{amount}}",
            a = Currency.moneyFormats[t][n || Currency.format] || "{{amount}}";
          r = s.indexOf("amount_no_decimals") !== -1 ? Currency.convert(100 * parseInt(i.replace(/[^0-9]/g, ""), 10), e, t) : "JOD" === e || "KWD" === e || "BHD" === e ? Currency.convert(parseInt(i.replace(/[^0-9]/g, ""), 10) / 10, e, t) : Currency.convert(parseInt(i.replace(/[^0-9]/g, ""), 10), e, t);
          var l = Shopify.formatMoney(r, a);
          o.html(l), o.attr("data-currency-" + t, l)
        }
        o.attr("data-currency", t)
      }
    }), this.currentCurrency = t, this.cookie.write(t)
  },
  function(e) {
    "function" == typeof define && define.amd ? define(["jquery"], e) : e("object" == typeof exports ? require("jquery") : window.jQuery || window.Zepto)
  }(function(e) {
    var t, o, n, i, r, s, a = "Close",
      l = "BeforeClose",
      c = "AfterClose",
      u = "BeforeAppend",
      d = "MarkupParse",
      p = "Open",
      m = "Change",
      f = "mfp",
      h = "." + f,
      y = "mfp-ready",
      g = "mfp-removing",
      v = "mfp-prevent-close",
      b = function() {},
      w = !!window.jQuery,
      _ = e(window),
      k = function(e, o) {
        t.ev.on(f + e + h, o)
      },
      T = function(t, o, n, i) {
        var r = document.createElement("div");
        return r.className = "mfp-" + t, n && (r.innerHTML = n), i ? o && o.appendChild(r) : (r = e(r), o && r.appendTo(o)), r
      },
      S = function(o, n) {
        t.ev.triggerHandler(f + o, n), t.st.callbacks && (o = o.charAt(0).toLowerCase() + o.slice(1), t.st.callbacks[o] && t.st.callbacks[o].apply(t, e.isArray(n) ? n : [n]))
      },
      C = function(o) {
        return o === s && t.currTemplate.closeBtn || (t.currTemplate.closeBtn = e(t.st.closeMarkup.replace("%title%", t.st.tClose)), s = o), t.currTemplate.closeBtn
      },
      x = function() {
        e.magnificPopup.instance || (t = new b, t.init(), e.magnificPopup.instance = t)
      },
      $ = function() {
        var e = document.createElement("p").style,
          t = ["ms", "O", "Moz", "Webkit"];
        if (void 0 !== e.transition) return !0;
        for (; t.length;)
          if (t.pop() + "Transition" in e) return !0;
        return !1
      };
    b.prototype = {
      constructor: b,
      init: function() {
        var o = navigator.appVersion;
        t.isLowIE = t.isIE8 = document.all && !document.addEventListener, t.isAndroid = /android/gi.test(o), t.isIOS = /iphone|ipad|ipod/gi.test(o), t.supportsTransition = $(), t.probablyMobile = t.isAndroid || t.isIOS || /(Opera Mini)|Kindle|webOS|BlackBerry|(Opera Mobi)|(Windows Phone)|IEMobile/i.test(navigator.userAgent), n = e(document), t.popupsCache = {}
      },
      open: function(o) {
        var i;
        if (o.isObj === !1) {
          t.items = o.items.toArray(), t.index = 0;
          var s, a = o.items;
          for (i = 0; i < a.length; i++)
            if (s = a[i], s.parsed && (s = s.el[0]), s === o.el[0]) {
              t.index = i;
              break
            }
        } else t.items = e.isArray(o.items) ? o.items : [o.items], t.index = o.index || 0;
        if (t.isOpen) return void t.updateItemHTML();
        t.types = [], r = "", o.mainEl && o.mainEl.length ? t.ev = o.mainEl.eq(0) : t.ev = n, o.key ? (t.popupsCache[o.key] || (t.popupsCache[o.key] = {}), t.currTemplate = t.popupsCache[o.key]) : t.currTemplate = {}, t.st = e.extend(!0, {}, e.magnificPopup.defaults, o), t.fixedContentPos = "auto" === t.st.fixedContentPos ? !t.probablyMobile : t.st.fixedContentPos, t.st.modal && (t.st.closeOnContentClick = !1, t.st.closeOnBgClick = !1, t.st.showCloseBtn = !1, t.st.enableEscapeKey = !1), t.bgOverlay || (t.bgOverlay = T("bg").on("click" + h, function() {
          t.close()
        }), t.wrap = T("wrap").attr("tabindex", -1).on("click" + h, function(e) {
          t._checkIfClose(e.target) && t.close()
        }), t.container = T("container", t.wrap)), t.contentContainer = T("content"), t.st.preloader && (t.preloader = T("preloader", t.container, t.st.tLoading));
        var l = e.magnificPopup.modules;
        for (i = 0; i < l.length; i++) {
          var c = l[i];
          c = c.charAt(0).toUpperCase() + c.slice(1), t["init" + c].call(t)
        }
        S("BeforeOpen"), t.st.showCloseBtn && (t.st.closeBtnInside ? (k(d, function(e, t, o, n) {
          o.close_replaceWith = C(n.type)
        }), r += " mfp-close-btn-in") : t.wrap.append(C())), t.st.alignTop && (r += " mfp-align-top"), t.fixedContentPos ? t.wrap.css({
          overflow: t.st.overflowY,
          overflowX: "hidden",
          overflowY: t.st.overflowY
        }) : t.wrap.css({
          top: _.scrollTop(),
          position: "absolute"
        }), (t.st.fixedBgPos === !1 || "auto" === t.st.fixedBgPos && !t.fixedContentPos) && t.bgOverlay.css({
          height: n.height(),
          position: "absolute"
        }), t.st.enableEscapeKey && n.on("keyup" + h, function(e) {
          27 === e.keyCode && t.close()
        }), _.on("resize" + h, function() {
          t.updateSize()
        }), t.st.closeOnContentClick || (r += " mfp-auto-cursor"), r && t.wrap.addClass(r);
        var u = t.wH = _.height(),
          m = {};
        if (t.fixedContentPos && t._hasScrollBar(u)) {
          var f = t._getScrollbarSize();
          f && (m.marginRight = f)
        }
        t.fixedContentPos && (t.isIE7 ? e("body, html").css("overflow", "hidden") : m.overflow = "hidden");
        var g = t.st.mainClass;
        return t.isIE7 && (g += " mfp-ie7"), g && t._addClassToMFP(g), t.updateItemHTML(), S("BuildControls"), e("html").css(m), t.bgOverlay.add(t.wrap).prependTo(t.st.prependTo || e(document.body)), t._lastFocusedEl = document.activeElement, setTimeout(function() {
          t.content ? (t._addClassToMFP(y), t._setFocus()) : t.bgOverlay.addClass(y), n.on("focusin" + h, t._onFocusIn)
        }, 16), t.isOpen = !0, t.updateSize(u), S(p), o
      },
      close: function() {
        t.isOpen && (S(l), t.isOpen = !1, t.st.removalDelay && !t.isLowIE && t.supportsTransition ? (t._addClassToMFP(g), setTimeout(function() {
          t._close()
        }, t.st.removalDelay)) : t._close())
      },
      _close: function() {
        S(a);
        var o = g + " " + y + " ";
        if (t.bgOverlay.detach(), t.wrap.detach(), t.container.empty(), t.st.mainClass && (o += t.st.mainClass + " "), t._removeClassFromMFP(o), t.fixedContentPos) {
          var i = {
            marginRight: ""
          };
          t.isIE7 ? e("body, html").css("overflow", "") : i.overflow = "", e("html").css(i)
        }
        n.off("keyup" + h + " focusin" + h), t.ev.off(h), t.wrap.attr("class", "mfp-wrap").removeAttr("style"), t.bgOverlay.attr("class", "mfp-bg"), t.container.attr("class", "mfp-container"), !t.st.showCloseBtn || t.st.closeBtnInside && t.currTemplate[t.currItem.type] !== !0 || t.currTemplate.closeBtn && t.currTemplate.closeBtn.detach(), t.st.autoFocusLast && t._lastFocusedEl && e(t._lastFocusedEl).focus(), t.currItem = null, t.content = null, t.currTemplate = null, t.prevHeight = 0, S(c)
      },
      updateSize: function(e) {
        if (t.isIOS) {
          var o = document.documentElement.clientWidth / window.innerWidth,
            n = window.innerHeight * o;
          t.wrap.css("height", n), t.wH = n
        } else t.wH = e || _.height();
        t.fixedContentPos || t.wrap.css("height", t.wH), S("Resize")
      },
      updateItemHTML: function() {
        var o = t.items[t.index];
        t.contentContainer.detach(), t.content && t.content.detach(), o.parsed || (o = t.parseEl(t.index));
        var n = o.type;
        if (S("BeforeChange", [t.currItem ? t.currItem.type : "", n]), t.currItem = o, !t.currTemplate[n]) {
          var r = !!t.st[n] && t.st[n].markup;
          S("FirstMarkupParse", r), r ? t.currTemplate[n] = e(r) : t.currTemplate[n] = !0
        }
        i && i !== o.type && t.container.removeClass("mfp-" + i + "-holder");
        var s = t["get" + n.charAt(0).toUpperCase() + n.slice(1)](o, t.currTemplate[n]);
        t.appendContent(s, n), o.preloaded = !0, S(m, o), i = o.type, t.container.prepend(t.contentContainer), S("AfterChange")
      },
      appendContent: function(e, o) {
        t.content = e, e ? t.st.showCloseBtn && t.st.closeBtnInside && t.currTemplate[o] === !0 ? t.content.find(".mfp-close").length || t.content.append(C()) : t.content = e : t.content = "", S(u), t.container.addClass("mfp-" + o + "-holder"), t.contentContainer.append(t.content)
      },
      parseEl: function(o) {
        var n, i = t.items[o];
        if (i.tagName ? i = {
            el: e(i)
          } : (n = i.type, i = {
            data: i,
            src: i.src
          }), i.el) {
          for (var r = t.types, s = 0; s < r.length; s++)
            if (i.el.hasClass("mfp-" + r[s])) {
              n = r[s];
              break
            }
          i.src = i.el.attr("data-mfp-src"), i.src || (i.src = i.el.attr("href"))
        }
        return i.type = n || t.st.type || "inline", i.index = o, i.parsed = !0, t.items[o] = i, S("ElementParse", i), t.items[o]
      },
      addGroup: function(e, o) {
        var n = function(n) {
          n.mfpEl = this, t._openClick(n, e, o)
        };
        o || (o = {});
        var i = "click.magnificPopup";
        o.mainEl = e, o.items ? (o.isObj = !0, e.off(i).on(i, n)) : (o.isObj = !1, o.delegate ? e.off(i).on(i, o.delegate, n) : (o.items = e, e.off(i).on(i, n)))
      },
      _openClick: function(o, n, i) {
        var r = void 0 !== i.midClick ? i.midClick : e.magnificPopup.defaults.midClick;
        if (r || !(2 === o.which || o.ctrlKey || o.metaKey || o.altKey || o.shiftKey)) {
          var s = void 0 !== i.disableOn ? i.disableOn : e.magnificPopup.defaults.disableOn;
          if (s)
            if (e.isFunction(s)) {
              if (!s.call(t)) return !0
            } else if (_.width() < s) return !0;
          o.type && (o.preventDefault(), t.isOpen && o.stopPropagation()), i.el = e(o.mfpEl), i.delegate && (i.items = n.find(i.delegate)), t.open(i)
        }
      },
      updateStatus: function(e, n) {
        if (t.preloader) {
          o !== e && t.container.removeClass("mfp-s-" + o), n || "loading" !== e || (n = t.st.tLoading);
          var i = {
            status: e,
            text: n
          };
          S("UpdateStatus", i), e = i.status, n = i.text, t.preloader.html(n), t.preloader.find("a").on("click", function(e) {
            e.stopImmediatePropagation()
          }), t.container.addClass("mfp-s-" + e), o = e
        }
      },
      _checkIfClose: function(o) {
        if (!e(o).hasClass(v)) {
          var n = t.st.closeOnContentClick,
            i = t.st.closeOnBgClick;
          if (n && i) return !0;
          if (!t.content || e(o).hasClass("mfp-close") || t.preloader && o === t.preloader[0]) return !0;
          if (o === t.content[0] || e.contains(t.content[0], o)) {
            if (n) return !0
          } else if (i && e.contains(document, o)) return !0;
          return !1
        }
      },
      _addClassToMFP: function(e) {
        t.bgOverlay.addClass(e), t.wrap.addClass(e)
      },
      _removeClassFromMFP: function(e) {
        this.bgOverlay.removeClass(e), t.wrap.removeClass(e)
      },
      _hasScrollBar: function(e) {
        return (t.isIE7 ? n.height() : document.body.scrollHeight) > (e || _.height())
      },
      _setFocus: function() {
        (t.st.focus ? t.content.find(t.st.focus).eq(0) : t.wrap).focus()
      },
      _onFocusIn: function(o) {
        if (o.target !== t.wrap[0] && !e.contains(t.wrap[0], o.target)) return t._setFocus(), !1
      },
      _parseMarkup: function(t, o, n) {
        var i;
        n.data && (o = e.extend(n.data, o)), S(d, [t, o, n]), e.each(o, function(o, n) {
          if (void 0 === n || n === !1) return !0;
          if (i = o.split("_"), i.length > 1) {
            var r = t.find(h + "-" + i[0]);
            if (r.length > 0) {
              var s = i[1];
              "replaceWith" === s ? r[0] !== n[0] && r.replaceWith(n) : "img" === s ? r.is("img") ? r.attr("src", n) : r.replaceWith(e("<img>").attr("src", n).attr("class", r.attr("class"))) : r.attr(i[1], n)
            }
          } else t.find(h + "-" + o).html(n)
        })
      },
      _getScrollbarSize: function() {
        if (void 0 === t.scrollbarSize) {
          var e = document.createElement("div");
          e.style.cssText = "width: 99px; height: 99px; overflow: scroll; position: absolute; top: -9999px;", document.body.appendChild(e), t.scrollbarSize = e.offsetWidth - e.clientWidth, document.body.removeChild(e)
        }
        return t.scrollbarSize
      }
    }, e.magnificPopup = {
      instance: null,
      proto: b.prototype,
      modules: [],
      open: function(t, o) {
        return x(), t = t ? e.extend(!0, {}, t) : {}, t.isObj = !0, t.index = o || 0, this.instance.open(t)
      },
      close: function() {
        return e.magnificPopup.instance && e.magnificPopup.instance.close()
      },
      registerModule: function(t, o) {
        o.options && (e.magnificPopup.defaults[t] = o.options), e.extend(this.proto, o.proto), this.modules.push(t)
      },
      defaults: {
        disableOn: 0,
        key: null,
        midClick: !1,
        mainClass: "",
        preloader: !0,
        focus: "",
        closeOnContentClick: !1,
        closeOnBgClick: !0,
        closeBtnInside: !0,
        showCloseBtn: !0,
        enableEscapeKey: !0,
        modal: !1,
        alignTop: !1,
        removalDelay: 0,
        prependTo: null,
        fixedContentPos: "auto",
        fixedBgPos: "auto",
        overflowY: "auto",
        closeMarkup: '<button title="%title%" type="button" class="mfp-close">&#215;</button>',
        tClose: "Close (Esc)",
        tLoading: "Loading...",
        autoFocusLast: !0
      }
    }, e.fn.magnificPopup = function(o) {
      x();
      var n = e(this);
      if ("string" == typeof o)
        if ("open" === o) {
          var i, r = w ? n.data("magnificPopup") : n[0].magnificPopup,
            s = parseInt(arguments[1], 10) || 0;
          r.items ? i = r.items[s] : (i = n, r.delegate && (i = i.find(r.delegate)), i = i.eq(s)), t._openClick({
            mfpEl: i
          }, n, r)
        } else t.isOpen && t[o].apply(t, Array.prototype.slice.call(arguments, 1));
      else o = e.extend(!0, {}, o), w ? n.data("magnificPopup", o) : n[0].magnificPopup = o, t.addGroup(n, o);
      return n
    };
    var E, O, A, I = "inline",
      P = function() {
        A && (O.after(A.addClass(E)).detach(), A = null)
      };
    e.magnificPopup.registerModule(I, {
      options: {
        hiddenClass: "hide",
        markup: "",
        tNotFound: "Content not found"
      },
      proto: {
        initInline: function() {
          t.types.push(I), k(a + "." + I, function() {
            P()
          })
        },
        getInline: function(o, n) {
          if (P(), o.src) {
            var i = t.st.inline,
              r = e(o.src);
            if (r.length) {
              var s = r[0].parentNode;
              s && s.tagName && (O || (E = i.hiddenClass, O = T(E), E = "mfp-" + E), A = r.after(O).detach().removeClass(E)), t.updateStatus("ready")
            } else t.updateStatus("error", i.tNotFound), r = e("<div>");
            return o.inlineElement = r, r
          }
          return t.updateStatus("ready"), t._parseMarkup(n, {}, o), n
        }
      }
    });
    var N, L = "ajax",
      M = function() {
        N && e(document.body).removeClass(N)
      },
      D = function() {
        M(), t.req && t.req.abort()
      };
    e.magnificPopup.registerModule(L, {
      options: {
        settings: null,
        cursor: "mfp-ajax-cur",
        tError: '<a href="%url%">The content</a> could not be loaded.'
      },
      proto: {
        initAjax: function() {
          t.types.push(L), N = t.st.ajax.cursor, k(a + "." + L, D), k("BeforeChange." + L, D)
        },
        getAjax: function(o) {
          N && e(document.body).addClass(N), t.updateStatus("loading");
          var n = e.extend({
            url: o.src,
            success: function(n, i, r) {
              var s = {
                data: n,
                xhr: r
              };
              S("ParseAjax", s), t.appendContent(e(s.data), L), o.finished = !0, M(), t._setFocus(), setTimeout(function() {
                t.wrap.addClass(y)
              }, 16), t.updateStatus("ready"), S("AjaxContentAdded")
            },
            error: function() {
              M(), o.finished = o.loadError = !0, t.updateStatus("error", t.st.ajax.tError.replace("%url%", o.src));
            }
          }, t.st.ajax.settings);
          return t.req = e.ajax(n), ""
        }
      }
    });
    var F, R = function(o) {
      if (o.data && void 0 !== o.data.title) return o.data.title;
      var n = t.st.image.titleSrc;
      if (n) {
        if (e.isFunction(n)) return n.call(t, o);
        if (o.el) return o.el.attr(n) || ""
      }
      return ""
    };
    e.magnificPopup.registerModule("image", {
      options: {
        markup: '<div class="mfp-figure"><div class="mfp-close"></div><figure><div class="mfp-img"></div><figcaption><div class="mfp-bottom-bar"><div class="mfp-title"></div><div class="mfp-counter"></div></div></figcaption></figure></div>',
        cursor: "mfp-zoom-out-cur",
        titleSrc: "title",
        verticalFit: !0,
        tError: '<a href="%url%">The image</a> could not be loaded.'
      },
      proto: {
        initImage: function() {
          var o = t.st.image,
            n = ".image";
          t.types.push("image"), k(p + n, function() {
            "image" === t.currItem.type && o.cursor && e(document.body).addClass(o.cursor)
          }), k(a + n, function() {
            o.cursor && e(document.body).removeClass(o.cursor), _.off("resize" + h)
          }), k("Resize" + n, t.resizeImage), t.isLowIE && k("AfterChange", t.resizeImage)
        },
        resizeImage: function() {
          var e = t.currItem;
          if (e && e.img && t.st.image.verticalFit) {
            var o = 0;
            t.isLowIE && (o = parseInt(e.img.css("padding-top"), 10) + parseInt(e.img.css("padding-bottom"), 10)), e.img.css("max-height", t.wH - o)
          }
        },
        _onImageHasSize: function(e) {
          e.img && (e.hasSize = !0, F && clearInterval(F), e.isCheckingImgSize = !1, S("ImageHasSize", e), e.imgHidden && (t.content && t.content.removeClass("mfp-loading"), e.imgHidden = !1))
        },
        findImageSize: function(e) {
          var o = 0,
            n = e.img[0],
            i = function(r) {
              F && clearInterval(F), F = setInterval(function() {
                return n.naturalWidth > 0 ? void t._onImageHasSize(e) : (o > 200 && clearInterval(F), o++, void(3 === o ? i(10) : 40 === o ? i(50) : 100 === o && i(500)))
              }, r)
            };
          i(1)
        },
        getImage: function(o, n) {
          var i = 0,
            r = function() {
              o && (o.img[0].complete ? (o.img.off(".mfploader"), o === t.currItem && (t._onImageHasSize(o), t.updateStatus("ready")), o.hasSize = !0, o.loaded = !0, S("ImageLoadComplete")) : (i++, i < 200 ? setTimeout(r, 100) : s()))
            },
            s = function() {
              o && (o.img.off(".mfploader"), o === t.currItem && (t._onImageHasSize(o), t.updateStatus("error", a.tError.replace("%url%", o.src))), o.hasSize = !0, o.loaded = !0, o.loadError = !0)
            },
            a = t.st.image,
            l = n.find(".mfp-img");
          if (l.length) {
            var c = document.createElement("img");
            c.className = "mfp-img", o.el && o.el.find("img").length && (c.alt = o.el.find("img").attr("alt")), o.img = e(c).on("load.mfploader", r).on("error.mfploader", s), c.src = o.src, l.is("img") && (o.img = o.img.clone()), c = o.img[0], c.naturalWidth > 0 ? o.hasSize = !0 : c.width || (o.hasSize = !1)
          }
          return t._parseMarkup(n, {
            title: R(o),
            img_replaceWith: o.img
          }, o), t.resizeImage(), o.hasSize ? (F && clearInterval(F), o.loadError ? (n.addClass("mfp-loading"), t.updateStatus("error", a.tError.replace("%url%", o.src))) : (n.removeClass("mfp-loading"), t.updateStatus("ready")), n) : (t.updateStatus("loading"), o.loading = !0, o.hasSize || (o.imgHidden = !0, n.addClass("mfp-loading"), t.findImageSize(o)), n)
        }
      }
    });
    var j, H = function() {
      return void 0 === j && (j = void 0 !== document.createElement("p").style.MozTransform), j
    };
    e.magnificPopup.registerModule("zoom", {
      options: {
        enabled: !1,
        easing: "ease-in-out",
        duration: 300,
        opener: function(e) {
          return e.is("img") ? e : e.find("img")
        }
      },
      proto: {
        initZoom: function() {
          var e, o = t.st.zoom,
            n = ".zoom";
          if (o.enabled && t.supportsTransition) {
            var i, r, s = o.duration,
              c = function(e) {
                var t = e.clone().removeAttr("style").removeAttr("class").addClass("mfp-animated-image"),
                  n = "all " + o.duration / 1e3 + "s " + o.easing,
                  i = {
                    position: "fixed",
                    zIndex: 9999,
                    left: 0,
                    top: 0,
                    "-webkit-backface-visibility": "hidden"
                  },
                  r = "transition";
                return i["-webkit-" + r] = i["-moz-" + r] = i["-o-" + r] = i[r] = n, t.css(i), t
              },
              u = function() {
                t.content.css("visibility", "visible")
              };
            k("BuildControls" + n, function() {
              if (t._allowZoom()) {
                if (clearTimeout(i), t.content.css("visibility", "hidden"), e = t._getItemToZoom(), !e) return void u();
                r = c(e), r.css(t._getOffset()), t.wrap.append(r), i = setTimeout(function() {
                  r.css(t._getOffset(!0)), i = setTimeout(function() {
                    u(), setTimeout(function() {
                      r.remove(), e = r = null, S("ZoomAnimationEnded")
                    }, 16)
                  }, s)
                }, 16)
              }
            }), k(l + n, function() {
              if (t._allowZoom()) {
                if (clearTimeout(i), t.st.removalDelay = s, !e) {
                  if (e = t._getItemToZoom(), !e) return;
                  r = c(e)
                }
                r.css(t._getOffset(!0)), t.wrap.append(r), t.content.css("visibility", "hidden"), setTimeout(function() {
                  r.css(t._getOffset())
                }, 16)
              }
            }), k(a + n, function() {
              t._allowZoom() && (u(), r && r.remove(), e = null)
            })
          }
        },
        _allowZoom: function() {
          return "image" === t.currItem.type
        },
        _getItemToZoom: function() {
          return !!t.currItem.hasSize && t.currItem.img
        },
        _getOffset: function(o) {
          var n;
          n = o ? t.currItem.img : t.st.zoom.opener(t.currItem.el || t.currItem);
          var i = n.offset(),
            r = parseInt(n.css("padding-top"), 10),
            s = parseInt(n.css("padding-bottom"), 10);
          i.top -= e(window).scrollTop() - r;
          var a = {
            width: n.width(),
            height: (w ? n.innerHeight() : n[0].offsetHeight) - s - r
          };
          return H() ? a["-moz-transform"] = a.transform = "translate(" + i.left + "px," + i.top + "px)" : (a.left = i.left, a.top = i.top), a
        }
      }
    });
    var B = "iframe",
      z = "//about:blank",
      W = function(e) {
        if (t.currTemplate[B]) {
          var o = t.currTemplate[B].find("iframe");
          o.length && (e || (o[0].src = z), t.isIE8 && o.css("display", e ? "block" : "none"))
        }
      };
    e.magnificPopup.registerModule(B, {
      options: {
        markup: '<div class="mfp-iframe-scaler"><div class="mfp-close"></div><iframe class="mfp-iframe" src="//about:blank" frameborder="0" allowfullscreen></iframe></div>',
        srcAction: "iframe_src",
        patterns: {
          youtube: {
            index: "youtube.com",
            id: "v=",
            src: "//www.youtube.com/embed/%id%?autoplay=1"
          },
          vimeo: {
            index: "vimeo.com/",
            id: "/",
            src: "//player.vimeo.com/video/%id%?autoplay=1"
          },
          gmaps: {
            index: "//maps.google.",
            src: "%id%&output=embed"
          }
        }
      },
      proto: {
        initIframe: function() {
          t.types.push(B), k("BeforeChange", function(e, t, o) {
            t !== o && (t === B ? W() : o === B && W(!0))
          }), k(a + "." + B, function() {
            W()
          })
        },
        getIframe: function(o, n) {
          var i = o.src,
            r = t.st.iframe;
          e.each(r.patterns, function() {
            if (i.indexOf(this.index) > -1) return this.id && (i = "string" == typeof this.id ? i.substr(i.lastIndexOf(this.id) + this.id.length, i.length) : this.id.call(this, i)), i = this.src.replace("%id%", i), !1
          });
          var s = {};
          return r.srcAction && (s[r.srcAction] = i), t._parseMarkup(n, s, o), t.updateStatus("ready"), n
        }
      }
    });
    var U = function(e) {
        var o = t.items.length;
        return e > o - 1 ? e - o : e < 0 ? o + e : e
      },
      q = function(e, t, o) {
        return e.replace(/%curr%/gi, t + 1).replace(/%total%/gi, o)
      };
    e.magnificPopup.registerModule("gallery", {
      options: {
        enabled: !1,
        arrowMarkup: '<button title="%title%" type="button" class="mfp-arrow mfp-arrow-%dir%"></button>',
        preload: [0, 2],
        navigateByImgClick: !0,
        arrows: !0,
        tPrev: "Previous (Left arrow key)",
        tNext: "Next (Right arrow key)",
        tCounter: "%curr% of %total%"
      },
      proto: {
        initGallery: function() {
          var o = t.st.gallery,
            i = ".mfp-gallery";
          return t.direction = !0, !(!o || !o.enabled) && (r += " mfp-gallery", k(p + i, function() {
            o.navigateByImgClick && t.wrap.on("click" + i, ".mfp-img", function() {
              if (t.items.length > 1) return t.next(), !1
            }), n.on("keydown" + i, function(e) {
              37 === e.keyCode ? t.prev() : 39 === e.keyCode && t.next()
            })
          }), k("UpdateStatus" + i, function(e, o) {
            o.text && (o.text = q(o.text, t.currItem.index, t.items.length))
          }), k(d + i, function(e, n, i, r) {
            var s = t.items.length;
            i.counter = s > 1 ? q(o.tCounter, r.index, s) : ""
          }), k("BuildControls" + i, function() {
            if (t.items.length > 1 && o.arrows && !t.arrowLeft) {
              var n = o.arrowMarkup,
                i = t.arrowLeft = e(n.replace(/%title%/gi, o.tPrev).replace(/%dir%/gi, "left")).addClass(v),
                r = t.arrowRight = e(n.replace(/%title%/gi, o.tNext).replace(/%dir%/gi, "right")).addClass(v);
              i.click(function() {
                t.prev()
              }), r.click(function() {
                t.next()
              }), t.container.append(i.add(r))
            }
          }), k(m + i, function() {
            t._preloadTimeout && clearTimeout(t._preloadTimeout), t._preloadTimeout = setTimeout(function() {
              t.preloadNearbyImages(), t._preloadTimeout = null
            }, 16)
          }), void k(a + i, function() {
            n.off(i), t.wrap.off("click" + i), t.arrowRight = t.arrowLeft = null
          }))
        },
        next: function() {
          t.direction = !0, t.index = U(t.index + 1), t.updateItemHTML()
        },
        prev: function() {
          t.direction = !1, t.index = U(t.index - 1), t.updateItemHTML()
        },
        goTo: function(e) {
          t.direction = e >= t.index, t.index = e, t.updateItemHTML()
        },
        preloadNearbyImages: function() {
          var e, o = t.st.gallery.preload,
            n = Math.min(o[0], t.items.length),
            i = Math.min(o[1], t.items.length);
          for (e = 1; e <= (t.direction ? i : n); e++) t._preloadItem(t.index + e);
          for (e = 1; e <= (t.direction ? n : i); e++) t._preloadItem(t.index - e)
        },
        _preloadItem: function(o) {
          if (o = U(o), !t.items[o].preloaded) {
            var n = t.items[o];
            n.parsed || (n = t.parseEl(o)), S("LazyLoad", n), "image" === n.type && (n.img = e('<img class="mfp-img" />').on("load.mfploader", function() {
              n.hasSize = !0
            }).on("error.mfploader", function() {
              n.hasSize = !0, n.loadError = !0, S("LazyLoadError", n)
            }).attr("src", n.src)), n.preloaded = !0
          }
        }
      }
    });
    var G = "retina";
    e.magnificPopup.registerModule(G, {
      options: {
        replaceSrc: function(e) {
          return e.src.replace(/\.\w+$/, function(e) {
            return "@2x" + e
          })
        },
        ratio: 1
      },
      proto: {
        initRetina: function() {
          if (window.devicePixelRatio > 1) {
            var e = t.st.retina,
              o = e.ratio;
            o = isNaN(o) ? o() : o, o > 1 && (k("ImageHasSize." + G, function(e, t) {
              t.img.css({
                "max-width": t.img[0].naturalWidth / o,
                width: "100%"
              })
            }), k("ElementParse." + G, function(t, n) {
              n.src = e.replaceSrc(n, o)
            }))
          }
        }
      }
    }), x()
  }),
  function() {
    function e(e, t) {
      t = t || {
        bubbles: !1,
        cancelable: !1,
        detail: void 0
      };
      var o = document.createEvent("CustomEvent");
      return o.initCustomEvent(e, t.bubbles, t.cancelable, t.detail), o
    }
    "function" != typeof window.CustomEvent && (e.prototype = window.Event.prototype, window.CustomEvent = e)
  }(), Array.prototype.find || Object.defineProperty(Array.prototype, "find", {
    value: function(e) {
      if (null == this) throw new TypeError('"this" is null or not defined');
      var t = Object(this),
        o = t.length >>> 0;
      if ("function" != typeof e) throw new TypeError("predicate must be a function");
      for (var n = arguments[1], i = 0; i < o;) {
        var r = t[i];
        if (e.call(n, r, i, t)) return r;
        i++
      }
    }
  }), new function(e) {
    var t = e.separator || "&",
      o = e.spaces !== !1,
      n = (e.suffix === !1 ? "" : "[]", e.prefix !== !1),
      i = n ? e.hash === !0 ? "#" : "?" : "",
      r = e.numbers !== !1;
    jQuery.query = new function() {
      var e = function(e, t) {
          return void 0 != e && null !== e && (!t || e.constructor == t)
        },
        n = function(e) {
          for (var t, o = /\[([^[]*)\]/g, n = /^([^[]+)(\[.*\])?$/.exec(e), i = n[1], r = []; t = o.exec(n[2]);) r.push(t[1]);
          return [i, r]
        },
        s = function(t, o, n) {
          var i = o.shift();
          if ("object" != typeof t && (t = null), "" === i)
            if (t || (t = []), e(t, Array)) t.push(0 == o.length ? n : s(null, o.slice(0), n));
            else if (e(t, Object)) {
            for (var r = 0; null != t[r++];);
            t[--r] = 0 == o.length ? n : s(t[r], o.slice(0), n)
          } else t = [], t.push(0 == o.length ? n : s(null, o.slice(0), n));
          else if (i && i.match(/^\s*[0-9]+\s*$/)) {
            var a = parseInt(i, 10);
            t || (t = []), t[a] = 0 == o.length ? n : s(t[a], o.slice(0), n)
          } else {
            if (!i) return n;
            var a = i.replace(/^\s*|\s*$/g, "");
            if (t || (t = {}), e(t, Array)) {
              for (var l = {}, r = 0; r < t.length; ++r) l[r] = t[r];
              t = l
            }
            t[a] = 0 == o.length ? n : s(t[a], o.slice(0), n)
          }
          return t
        },
        a = function(e) {
          var t = this;
          return t.keys = {}, e.queryObject ? jQuery.each(e.get(), function(e, o) {
            t.SET(e, o)
          }) : t.parseNew.apply(t, arguments), t
        };
      return a.prototype = {
        queryObject: !0,
        parseNew: function() {
          var e = this;
          return e.keys = {}, jQuery.each(arguments, function() {
            var t = "" + this;
            t = t.replace(/^[?#]/, ""), t = t.replace(/[;&]$/, ""), o && (t = t.replace(/[+]/g, " ")), jQuery.each(t.split(/[&;]/), function() {
              var t = decodeURIComponent(this.split("=")[0] || ""),
                o = decodeURIComponent(this.split("=")[1] || "");
              t && (r && (/^[+-]?[0-9]+\.[0-9]*$/.test(o) ? o = parseFloat(o) : /^[+-]?[1-9][0-9]*$/.test(o) && (o = parseInt(o, 10))), o = !o && 0 !== o || o, e.SET(t, o))
            })
          }), e
        },
        has: function(t, o) {
          var n = this.get(t);
          return e(n, o)
        },
        GET: function(t) {
          if (!e(t)) return this.keys;
          for (var o = n(t), i = o[0], r = o[1], s = this.keys[i]; null != s && 0 != r.length;) s = s[r.shift()];
          return "number" == typeof s ? s : s || ""
        },
        get: function(t) {
          var o = this.GET(t);
          return e(o, Object) ? jQuery.extend(!0, {}, o) : e(o, Array) ? o.slice(0) : o
        },
        SET: function(t, o) {
          var i = e(o) ? o : null,
            r = n(t),
            a = r[0],
            l = r[1],
            c = this.keys[a];
          return this.keys[a] = s(c, l.slice(0), i), this
        },
        set: function(e, t) {
          return this.copy().SET(e, t)
        },
        REMOVE: function(t, o) {
          if (o) {
            var n = this.GET(t);
            if (e(n, Array)) {
              for (tval in n) n[tval] = n[tval].toString();
              var i = $.inArray(o, n);
              if (!(i >= 0)) return;
              t = n.splice(i, 1), t = t[i]
            } else if (o != n) return
          }
          return this.SET(t, null).COMPACT()
        },
        remove: function(e, t) {
          return this.copy().REMOVE(e, t)
        },
        EMPTY: function() {
          var e = this;
          return jQuery.each(e.keys, function(t, o) {
            delete e.keys[t]
          }), e
        },
        load: function(e) {
          var t = e.replace(/^.*?[#](.+?)(?:\?.+)?$/, "$1"),
            o = e.replace(/^.*?[?](.+?)(?:#.+)?$/, "$1");
          return new a(e.length == o.length ? "" : o, e.length == t.length ? "" : t)
        },
        empty: function() {
          return this.copy().EMPTY()
        },
        copy: function() {
          return new a(this)
        },
        COMPACT: function() {
          function t(o) {
            function n(t, o, n) {
              e(t, Array) ? t.push(n) : t[o] = n
            }
            var i = "object" == typeof o ? e(o, Array) ? [] : {} : o;
            return "object" == typeof o && jQuery.each(o, function(o, r) {
              return !e(r) || void n(i, o, t(r))
            }), i
          }
          return this.keys = t(this.keys), this
        },
        compact: function() {
          return this.copy().COMPACT()
        },
        toString: function() {
          var n = [],
            r = [],
            s = function(e) {
              return e += "", e = encodeURIComponent(e), o && (e = e.replace(/%20/g, "+")), e
            },
            a = function(t, o, n) {
              if (e(n) && n !== !1) {
                var i = [s(o)];
                n !== !0 && (i.push("="), i.push(s(n))), t.push(i.join(""))
              }
            },
            l = function(e, t) {
              var o = function(e) {
                return t && "" != t ? [t, "[", e, "]"].join("") : [e].join("")
              };
              jQuery.each(e, function(e, t) {
                "object" == typeof t ? l(t, o(e)) : a(r, o(e), t)
              })
            };
          return l(this.keys), r.length > 0 && n.push(i), n.push(r.join(t)), n.join("")
        }
      }, new a(location.search, location.hash)
    }
  }(jQuery.query || {}), ! function(e, t) {
    "function" == typeof define && define.amd ? define(["jquery"], function(o) {
      return t(e, o)
    }) : "object" == typeof exports ? t(e, require("jquery")) : t(e, e.jQuery || e.Zepto)
  }(this, function(e, t) {
    "use strict";

    function o(e) {
      if (k && "none" === e.css("animation-name") && "none" === e.css("-webkit-animation-name") && "none" === e.css("-moz-animation-name") && "none" === e.css("-o-animation-name") && "none" === e.css("-ms-animation-name")) return 0;
      var t, o, n, i, r = e.css("animation-duration") || e.css("-webkit-animation-duration") || e.css("-moz-animation-duration") || e.css("-o-animation-duration") || e.css("-ms-animation-duration") || "0s",
        s = e.css("animation-delay") || e.css("-webkit-animation-delay") || e.css("-moz-animation-delay") || e.css("-o-animation-delay") || e.css("-ms-animation-delay") || "0s",
        a = e.css("animation-iteration-count") || e.css("-webkit-animation-iteration-count") || e.css("-moz-animation-iteration-count") || e.css("-o-animation-iteration-count") || e.css("-ms-animation-iteration-count") || "1";
      for (r = r.split(", "), s = s.split(", "), a = a.split(", "), i = 0, o = r.length, t = Number.NEGATIVE_INFINITY; i < o; i++) n = parseFloat(r[i]) * parseInt(a[i], 10) + parseFloat(s[i]), n > t && (t = n);
      return t
    }

    function n() {
      if (t(document.body).height() <= t(window).height()) return 0;
      var e, o, n = document.createElement("div"),
        i = document.createElement("div");
      return n.style.visibility = "hidden", n.style.width = "100px", document.body.appendChild(n), e = n.offsetWidth, n.style.overflow = "scroll", i.style.width = "100%", n.appendChild(i), o = i.offsetWidth, n.parentNode.removeChild(n), e - o
    }

    function i() {
      if (!T) {
        var e, o, i = t("html"),
          r = u("is-locked");
        i.hasClass(r) || (o = t(document.body), e = parseInt(o.css("padding-right"), 10) + n(), o.css("padding-right", e + "px"), i.addClass(r))
      }
    }

    function r() {
      if (!T) {
        var e, o, i = t("html"),
          r = u("is-locked");
        i.hasClass(r) && (o = t(document.body), e = parseInt(o.css("padding-right"), 10) - n(), o.css("padding-right", e + "px"), i.removeClass(r))
      }
    }

    function s(e, t, o, n) {
      var i = u("is", t),
        r = [u("is", w.CLOSING), u("is", w.OPENING), u("is", w.CLOSED), u("is", w.OPENED)].join(" ");
      e.$bg.removeClass(r).addClass(i), e.$overlay.removeClass(r).addClass(i), e.$wrapper.removeClass(r).addClass(i), e.$modal.removeClass(r).addClass(i), e.state = t, !o && e.$modal.trigger({
        type: t,
        reason: n
      }, [{
        reason: n
      }])
    }

    function a(e, n, i) {
      var r = 0,
        s = function(e) {
          e.target === this && r++
        },
        a = function(e) {
          e.target === this && 0 === --r && (t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
            i[t].off(g + " " + v)
          }), n())
        };
      t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
        i[t].on(g, s).on(v, a)
      }), e(), 0 === o(i.$bg) && 0 === o(i.$overlay) && 0 === o(i.$wrapper) && 0 === o(i.$modal) && (t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(e, t) {
        i[t].off(g + " " + v)
      }), n())
    }

    function l(e) {
      e.state !== w.CLOSED && (t.each(["$bg", "$overlay", "$wrapper", "$modal"], function(t, o) {
        e[o].off(g + " " + v)
      }), e.$bg.removeClass(e.settings.modifier), e.$overlay.removeClass(e.settings.modifier).hide(), e.$wrapper.hide(), r(), s(e, w.CLOSED, !0))
    }

    function c(e) {
      var t, o, n, i, r = {};
      for (e = e.replace(/\s*:\s*/g, ":").replace(/\s*,\s*/g, ","), t = e.split(","), i = 0, o = t.length; i < o; i++) t[i] = t[i].split(":"), n = t[i][1], ("string" == typeof n || n instanceof String) && (n = "true" === n || "false" !== n && n), ("string" == typeof n || n instanceof String) && (n = isNaN(n) ? n : +n), r[t[i][0]] = n;
      return r
    }

    function u() {
      for (var e = y, t = 0; t < arguments.length; ++t) e += "-" + arguments[t];
      return e
    }

    function d() {
      var e, o, n = location.hash.replace("#", "");
      if (n) {
        try {
          o = t('[data-remodal-id="' + n + '"]')
        } catch (i) {}
        o && o.length && (e = t[h].lookup[o.data(h)], e && e.settings.hashTracking && e.open())
      } else m && m.state === w.OPENED && m.settings.hashTracking && m.close()
    }

    function p(e, o) {
      var n = t(document.body),
        i = n,
        r = this;
      r.settings = t.extend({}, b, o), r.index = t[h].lookup.push(r) - 1, r.state = w.CLOSED, r.$overlay = t("." + u("overlay")), null !== r.settings.appendTo && r.settings.appendTo.length && (i = t(r.settings.appendTo)), r.$overlay.length || (r.$overlay = t("<div>").addClass(u("overlay") + " " + u("is", w.CLOSED)).hide(), i.append(r.$overlay)), r.$bg = t("." + u("bg")).addClass(u("is", w.CLOSED)), r.$modal = e.addClass(y + " " + u("is-initialized") + " " + r.settings.modifier + " " + u("is", w.CLOSED)).attr("tabindex", "-1"), r.$wrapper = t("<div>").addClass(u("wrapper") + " " + r.settings.modifier + " " + u("is", w.CLOSED)).hide().append(r.$modal), i.append(r.$wrapper), r.$wrapper.on("click." + y, '[data-remodal-action="close"]', function(e) {
        e.preventDefault(), r.close()
      }), r.$wrapper.on("click." + y, '[data-remodal-action="cancel"]', function(e) {
        e.preventDefault(), r.$modal.trigger(_.CANCELLATION), r.settings.closeOnCancel && r.close(_.CANCELLATION)
      }), r.$wrapper.on("click." + y, '[data-remodal-action="confirm"]', function(e) {
        e.preventDefault(), r.$modal.trigger(_.CONFIRMATION), r.settings.closeOnConfirm && r.close(_.CONFIRMATION)
      }), r.$wrapper.on("click." + y, function(e) {
        var o = t(e.target);
        o.hasClass(u("wrapper")) && r.settings.closeOnOutsideClick && r.close()
      })
    }
    var m, f, h = "remodal",
      y = e.REMODAL_GLOBALS && e.REMODAL_GLOBALS.NAMESPACE || h,
      g = t.map(["animationstart", "webkitAnimationStart", "MSAnimationStart", "oAnimationStart"], function(e) {
        return e + "." + y
      }).join(" "),
      v = t.map(["animationend", "webkitAnimationEnd", "MSAnimationEnd", "oAnimationEnd"], function(e) {
        return e + "." + y
      }).join(" "),
      b = t.extend({
        hashTracking: !0,
        closeOnConfirm: !0,
        closeOnCancel: !0,
        closeOnEscape: !0,
        closeOnOutsideClick: !0,
        modifier: "",
        appendTo: null
      }, e.REMODAL_GLOBALS && e.REMODAL_GLOBALS.DEFAULTS),
      w = {
        CLOSING: "closing",
        CLOSED: "closed",
        OPENING: "opening",
        OPENED: "opened"
      },
      _ = {
        CONFIRMATION: "confirmation",
        CANCELLATION: "cancellation"
      },
      k = function() {
        var e = document.createElement("div").style;
        return void 0 !== e.animationName || void 0 !== e.WebkitAnimationName || void 0 !== e.MozAnimationName || void 0 !== e.msAnimationName || void 0 !== e.OAnimationName
      }(),
      T = /iPad|iPhone|iPod/.test(navigator.platform);
    p.prototype.open = function() {
      var e, o = this;
      o.state !== w.OPENING && o.state !== w.CLOSING && (e = o.$modal.attr("data-remodal-id"), e && o.settings.hashTracking && (f = t(window).scrollTop(), location.hash = e), m && m !== o && l(m), m = o, i(), o.$bg.addClass(o.settings.modifier), o.$overlay.addClass(o.settings.modifier).show(), o.$wrapper.show().scrollTop(0), o.$modal.focus(), a(function() {
        s(o, w.OPENING)
      }, function() {
        s(o, w.OPENED)
      }, o))
    }, p.prototype.close = function(e) {
      var o = this;
      o.state !== w.OPENING && o.state !== w.CLOSING && (o.settings.hashTracking && o.$modal.attr("data-remodal-id") === location.hash.substr(1) && (location.hash = "", t(window).scrollTop(f)), a(function() {
        s(o, w.CLOSING, !1, e)
      }, function() {
        o.$bg.removeClass(o.settings.modifier), o.$overlay.removeClass(o.settings.modifier).hide(), o.$wrapper.hide(), r(), s(o, w.CLOSED, !1, e)
      }, o))
    }, p.prototype.getState = function() {
      return this.state
    }, p.prototype.destroy = function() {
      var e, o = t[h].lookup;
      l(this), this.$wrapper.remove(), delete o[this.index], e = t.grep(o, function(e) {
        return !!e
      }).length, 0 === e && (this.$overlay.remove(), this.$bg.removeClass(u("is", w.CLOSING) + " " + u("is", w.OPENING) + " " + u("is", w.CLOSED) + " " + u("is", w.OPENED)))
    }, t[h] = {
      lookup: []
    }, t.fn[h] = function(e) {
      var o, n;
      return this.each(function(i, r) {
        n = t(r), null == n.data(h) ? (o = new p(n, e), n.data(h, o.index), o.settings.hashTracking && n.attr("data-remodal-id") === location.hash.substr(1) && o.open()) : o = t[h].lookup[n.data(h)]
      }), o
    }, t(document).ready(function() {
      t(document).on("click", "[data-remodal-target]", function(e) {
        e.preventDefault();
        var o = e.currentTarget,
          n = o.getAttribute("data-remodal-target"),
          i = t('[data-remodal-id="' + n + '"]');
        t[h].lookup[i.data(h)].open()
      }), t(document).find("." + y).each(function(e, o) {
        var n = t(o),
          i = n.data("remodal-options");
        i ? ("string" == typeof i || i instanceof String) && (i = c(i)) : i = {}, n[h](i)
      }), t(document).on("keydown." + y, function(e) {
        m && m.settings.closeOnEscape && m.state === w.OPENED && 27 === e.keyCode && m.close()
      }), t(window).on("hashchange." + y, d)
    })
  }),
  function(e, t) {
    "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? module.exports = t() : e.RouterRouter = t()
  }(this, function() {
    "use strict";
    var e = /[\-{}\[\]+?.,\\\^$|#\s]/g,
      t = /(\(\?)?:\w+/g,
      o = /\((.*?)\)/g,
      n = /\*\w+/g,
      i = /^[#\/]|\s+$/g,
      r = /\/$/,
      s = function(e) {
        if (e)
          for (var t, o = Object.keys(e);
            "undefined" != typeof(t = o.pop());) this.route(t, e[t])
      },
      a = function(e, t) {
        var o = e.exec(t).slice(1);
        return o.map(function(e) {
          return e ? decodeURIComponent(e) : null
        })
      },
      l = function(e) {
        return e.replace(i, "").replace(r, "");
      },
      c = function(e, t) {
        return Object.prototype.toString.call(e) === "[object " + t + "]"
      },
      u = function(i) {
        return i = i.replace(e, "\\$&").replace(o, "(?:$1)?").replace(t, function(e, t) {
          return t ? e : "([^/?]+)"
        }).replace(n, "([^?]*?)"), new RegExp("^" + i + "(?:\\?([\\s\\S]*))?$")
      },
      d = function(e) {
        this.options = e || {}, s(this.options.routes)
      };
    return d.prototype.route = function(e, t, o) {
      c(e, "RegExp") || (e = u(e)), c(t, "Function") && (o = t, t = ""), o || (o = this.options[t]);
      var n = l(window.location.pathname);
      if (e.test(n)) {
        var i = a(e, n);
        c(o, "Function") && o.apply(this, i)
      }
      return this
    }, d
  }), Shopify.utils = {
    defaultTo: function(e, t) {
      return null == e || e !== e ? t : e
    }
  }, Shopify.formatMoney = function(e, t) {
    function o(e, t, o, n) {
      if (t = Shopify.utils.defaultTo(t, 2), o = Shopify.utils.defaultTo(o, ","), n = Shopify.utils.defaultTo(n, "."), isNaN(e) || null == e) return 0;
      e = (e / 100).toFixed(t);
      var i = e.split("."),
        r = i[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + o),
        s = i[1] ? n + i[1] : "";
      return r + s
    }
    var n = "${{amount}}";
    "string" == typeof e && (e = e.replace(".", ""));
    var i = "",
      r = /\{\{\s*(\w+)\s*\}\}/,
      s = t || n;
    switch (s.match(r)[1]) {
      case "amount":
        i = o(e, 2);
        break;
      case "amount_no_decimals":
        i = o(e, 0);
        break;
      case "amount_with_comma_separator":
        i = o(e, 2, ".", ",");
        break;
      case "amount_no_decimals_with_comma_separator":
        i = o(e, 0, ".", ",");
        break;
      case "amount_no_decimals_with_space_separator":
        i = o(e, 0, " ")
    }
    return s.replace(r, i)
  },
  function(e, t) {
    function o() {
      S = O = C = x = $ = E = D
    }

    function n(e, t) {
      for (var o in t) t.hasOwnProperty(o) && (e[o] = t[o])
    }

    function i(e) {
      return parseFloat(e) || 0
    }

    function r() {
      I = {
        top: t.pageYOffset,
        left: t.pageXOffset
      }
    }

    function s() {
      return t.pageXOffset != I.left ? (r(), void C()) : void(t.pageYOffset != I.top && (r(), l()))
    }

    function a(e) {
      setTimeout(function() {
        t.pageYOffset != I.top && (I.top = t.pageYOffset, l())
      }, 0)
    }

    function l() {
      for (var e = N.length - 1; e >= 0; e--) c(N[e])
    }

    function c(e) {
      if (e.inited) {
        var t = I.top <= e.limit.start ? 0 : I.top >= e.limit.end ? 2 : 1;
        e.mode != t && h(e, t)
      }
    }

    function u() {
      for (var e = N.length - 1; e >= 0; e--)
        if (N[e].inited) {
          var t = Math.abs(b(N[e].clone) - N[e].docOffsetTop),
            o = Math.abs(N[e].parent.node.offsetHeight - N[e].parent.height);
          if (t >= 2 || o >= 2) return !1
        }
      return !0
    }

    function d(e) {
      isNaN(parseFloat(e.computed.top)) || e.isCell || "none" == e.computed.display || (e.inited = !0, e.clone || y(e), "absolute" != e.parent.computed.position && "relative" != e.parent.computed.position && (e.parent.node.style.position = "relative"), c(e), e.parent.height = e.parent.node.offsetHeight, e.docOffsetTop = b(e.clone))
    }

    function p(e) {
      var t = !0;
      e.clone && g(e), n(e.node.style, e.css);
      for (var o = N.length - 1; o >= 0; o--)
        if (N[o].node !== e.node && N[o].parent.node === e.parent.node) {
          t = !1;
          break
        }
      t && (e.parent.node.style.position = e.parent.css.position), e.mode = -1
    }

    function m() {
      for (var e = N.length - 1; e >= 0; e--) d(N[e])
    }

    function f() {
      for (var e = N.length - 1; e >= 0; e--) p(N[e])
    }

    function h(e, t) {
      var o = e.node.style;
      switch (t) {
        case 0:
          o.position = "absolute", o.left = e.offset.left + "px", o.right = e.offset.right + "px", o.top = e.offset.top + "px", o.bottom = "auto", o.width = "auto", o.marginLeft = 0, o.marginRight = 0, o.marginTop = 0;
          break;
        case 1:
          o.position = "fixed", o.left = e.box.left + "px", o.right = e.box.right + "px", o.top = e.css.top, o.bottom = "auto", o.width = "auto", o.marginLeft = 0, o.marginRight = 0, o.marginTop = 0;
          break;
        case 2:
          o.position = "absolute", o.left = e.offset.left + "px", o.right = e.offset.right + "px", o.top = "auto", o.bottom = 0, o.width = "auto", o.marginLeft = 0, o.marginRight = 0
      }
      e.mode = t
    }

    function y(e) {
      e.clone = document.createElement("div");
      var t = e.node.nextSibling || e.node,
        o = e.clone.style;
      o.height = e.height + "px", o.width = e.width + "px", o.marginTop = e.computed.marginTop, o.marginBottom = e.computed.marginBottom, o.marginLeft = e.computed.marginLeft, o.marginRight = e.computed.marginRight, o.padding = o.border = o.borderSpacing = 0, o.fontSize = "1em", o.position = "static", o.display = "inline-block", o.cssFloat = e.computed.cssFloat, e.node.parentNode.insertBefore(e.clone, t)
    }

    function g(e) {
      e.clone.parentNode.removeChild(e.clone), e.clone = void 0
    }

    function v(e) {
      var t = getComputedStyle(e),
        o = e.parentNode,
        n = getComputedStyle(o),
        r = e.style.position;
      e.style.position = "relative";
      var s = {
          top: t.top,
          marginTop: t.marginTop,
          marginBottom: t.marginBottom,
          marginLeft: t.marginLeft,
          marginRight: t.marginRight,
          cssFloat: t.cssFloat,
          display: t.display
        },
        a = {
          top: i(t.top),
          marginBottom: i(t.marginBottom),
          paddingLeft: i(t.paddingLeft),
          paddingRight: i(t.paddingRight),
          borderLeftWidth: i(t.borderLeftWidth),
          borderRightWidth: i(t.borderRightWidth)
        };
      e.style.position = r;
      var l = {
          position: e.style.position,
          top: e.style.top,
          bottom: e.style.bottom,
          left: e.style.left,
          right: e.style.right,
          width: e.style.width,
          marginTop: e.style.marginTop,
          marginLeft: e.style.marginLeft,
          marginRight: e.style.marginRight
        },
        c = w(e),
        u = w(o),
        d = {
          node: o,
          css: {
            position: o.style.position
          },
          computed: {
            position: n.position
          },
          numeric: {
            borderLeftWidth: i(n.borderLeftWidth),
            borderRightWidth: i(n.borderRightWidth),
            borderTopWidth: i(n.borderTopWidth),
            borderBottomWidth: i(n.borderBottomWidth)
          }
        },
        p = {
          node: e,
          box: {
            left: c.win.left,
            right: M.clientWidth - c.win.right
          },
          offset: {
            top: c.win.top - u.win.top - d.numeric.borderTopWidth,
            left: c.win.left - u.win.left - d.numeric.borderLeftWidth,
            right: -c.win.right + u.win.right - d.numeric.borderRightWidth
          },
          css: l,
          isCell: "table-cell" == t.display,
          computed: s,
          numeric: a,
          width: c.win.right - c.win.left,
          height: c.win.bottom - c.win.top,
          mode: -1,
          inited: !1,
          parent: d,
          limit: {
            start: c.doc.top - a.top,
            end: u.doc.top + o.offsetHeight - d.numeric.borderBottomWidth - e.offsetHeight - a.top - a.marginBottom
          }
        };
      return p
    }

    function b(e) {
      for (var t = 0; e;) t += e.offsetTop, e = e.offsetParent;
      return t
    }

    function w(e) {
      var o = e.getBoundingClientRect();
      return {
        doc: {
          top: o.top + t.pageYOffset,
          left: o.left + t.pageXOffset
        },
        win: o
      }
    }

    function _() {
      P = setInterval(function() {
        !u() && C()
      }, 500)
    }

    function k() {
      clearInterval(P)
    }

    function T() {
      L && (document[F] ? k() : _())
    }

    function S() {
      L || (r(), m(), t.addEventListener("scroll", s), t.addEventListener("wheel", a), t.addEventListener("resize", C), t.addEventListener("orientationchange", C), e.addEventListener(R, T), _(), L = !0)
    }

    function C() {
      if (L) {
        f();
        for (var e = N.length - 1; e >= 0; e--) N[e] = v(N[e].node);
        m()
      }
    }

    function x() {
      t.removeEventListener("scroll", s), t.removeEventListener("wheel", a), t.removeEventListener("resize", C), t.removeEventListener("orientationchange", C), e.removeEventListener(R, T), k(), L = !1
    }

    function $() {
      x(), f()
    }

    function E() {
      for ($(); N.length;) N.pop()
    }

    function O(e) {
      for (var t = N.length - 1; t >= 0; t--)
        if (N[t].node === e) return;
      var o = v(e);
      N.push(o), L ? d(o) : S()
    }

    function A(e) {
      for (var t = N.length - 1; t >= 0; t--) N[t].node === e && (p(N[t]), N.splice(t, 1))
    }
    var I, P, N = [],
      L = !1,
      M = e.documentElement,
      D = function() {},
      F = "hidden",
      R = "visibilitychange";
    void 0 !== e.webkitHidden && (F = "webkitHidden", R = "webkitvisibilitychange"), t.getComputedStyle || o();
    for (var j = ["", "-webkit-", "-moz-", "-ms-"], H = document.createElement("div"), B = j.length - 1; B >= 0; B--) {
      try {
        H.style.position = j[B] + "sticky"
      } catch (z) {}
      "" != H.style.position && o()
    }
    r(), t.Stickyfill = {
      stickies: N,
      add: O,
      remove: A,
      init: S,
      rebuild: C,
      pause: x,
      stop: $,
      kill: E
    }
  }(document, window), window.jQuery && ! function(e) {
    e.fn.Stickyfill = function(e) {
      return this.each(function() {
        Stickyfill.add(this)
      }), this
    }
  }(window.jQuery), window.Template7 = function() {
    "use strict";

    function e(e) {
      return "[object Array]" === Object.prototype.toString.apply(e)
    }

    function t(e) {
      return "function" == typeof e
    }

    function o(e) {
      return "undefined" != typeof window && window.escape ? window.escape(e) : e.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;")
    }

    function n(e) {
      var t, o, n, i = e.replace(/[{}#}]/g, "").split(" "),
        a = [];
      for (o = 0; o < i.length; o++) {
        var l, c, u = i[o];
        if (0 === o) a.push(u);
        else if (0 === u.indexOf('"') || 0 === u.indexOf("'"))
          if (l = 0 === u.indexOf('"') ? s : r, c = 0 === u.indexOf('"') ? '"' : "'", 2 === u.match(l).length) a.push(u);
          else {
            for (t = 0, n = o + 1; n < i.length; n++)
              if (u += " " + i[n], i[n].indexOf(c) >= 0) {
                t = n, a.push(u);
                break
              }
            t && (o = t)
          }
        else if (u.indexOf("=") > 0) {
          var d = u.split("="),
            p = d[0],
            m = d[1];
          if (2 !== m.match(l).length) {
            for (t = 0, n = o + 1; n < i.length; n++)
              if (m += " " + i[n], i[n].indexOf(c) >= 0) {
                t = n;
                break
              }
            t && (o = t)
          }
          var f = [p, m.replace(l, "")];
          a.push(f)
        } else a.push(u)
      }
      return a
    }

    function i(t) {
      var o, i, r = [];
      if (!t) return [];
      var s = t.split(/({{[^{^}]*}})/);
      for (o = 0; o < s.length; o++) {
        var a = s[o];
        if ("" !== a)
          if (a.indexOf("{{") < 0) r.push({
            type: "plain",
            content: a
          });
          else {
            if (a.indexOf("{/") >= 0) continue;
            if (a.indexOf("{#") < 0 && a.indexOf(" ") < 0 && a.indexOf("else") < 0) {
              r.push({
                type: "variable",
                contextName: a.replace(/[{}]/g, "")
              });
              continue
            }
            var l = n(a),
              c = l[0],
              u = ">" === c,
              d = [],
              p = {};
            for (i = 1; i < l.length; i++) {
              var m = l[i];
              e(m) ? p[m[0]] = "false" !== m[1] && m[1] : d.push(m)
            }
            if (a.indexOf("{#") >= 0) {
              var f, h = "",
                y = "",
                g = 0,
                v = !1,
                b = !1,
                w = 0;
              for (i = o + 1; i < s.length; i++)
                if (s[i].indexOf("{{#") >= 0 && w++, s[i].indexOf("{{/") >= 0 && w--, s[i].indexOf("{{#" + c) >= 0) h += s[i], b && (y += s[i]), g++;
                else if (s[i].indexOf("{{/" + c) >= 0) {
                if (!(g > 0)) {
                  f = i, v = !0;
                  break
                }
                g--, h += s[i], b && (y += s[i])
              } else s[i].indexOf("else") >= 0 && 0 === w ? b = !0 : (b || (h += s[i]), b && (y += s[i]));
              v && (f && (o = f), r.push({
                type: "helper",
                helperName: c,
                contextName: d,
                content: h,
                inverseContent: y,
                hash: p
              }))
            } else a.indexOf(" ") > 0 && (u && (c = "_partial", d[0] && (d[0] = '"' + d[0].replace(/"|'/g, "") + '"')), r.push({
              type: "helper",
              helperName: c,
              contextName: d,
              hash: p
            }))
          }
      }
      return r
    }
    var r = new RegExp("'", "g"),
      s = new RegExp('"', "g"),
      a = function(e, t) {
        function o(e, t) {
          return e.content ? a(e.content, t) : function() {
            return ""
          }
        }

        function n(e, t) {
          return e.inverseContent ? a(e.inverseContent, t) : function() {
            return ""
          }
        }

        function r(e, t) {
          var o, n, i = 0;
          if (0 === e.indexOf("../")) {
            i = e.split("../").length - 1;
            var r = t.split("_")[1] - i;
            t = "ctx_" + (r >= 1 ? r : 1), n = e.split("../")[i].split(".")
          } else 0 === e.indexOf("@global") ? (t = "Template7.global", n = e.split("@global.")[1].split(".")) : 0 === e.indexOf("@root") ? (t = "root", n = e.split("@root.")[1].split(".")) : n = e.split(".");
          o = t;
          for (var s = 0; s < n.length; s++) {
            var a = n[s];
            0 === a.indexOf("@") ? s > 0 ? o += "[(data && data." + a.replace("@", "") + ")]" : o = "(data && data." + e.replace("@", "") + ")" : isFinite(a) ? o += "[" + a + "]" : "this" === a || a.indexOf("this.") >= 0 || a.indexOf("this[") >= 0 || a.indexOf("this(") >= 0 ? o = a.replace("this", t) : o += "." + a
          }
          return o
        }

        function s(e, t) {
          for (var o = [], n = 0; n < e.length; n++) /^['"]/.test(e[n]) ? o.push(e[n]) : /^(true|false|\d+)$/.test(e[n]) ? o.push(e[n]) : o.push(r(e[n], t));
          return o.join(", ")
        }

        function a(e, t) {
          if (t = t || 1, e = e || l.template, "string" != typeof e) throw new Error("Template7: Template must be a string");
          var a = i(e);
          if (0 === a.length) return function() {
            return ""
          };
          var c = "ctx_" + t,
            u = "";
          u += 1 === t ? "(function (" + c + ", data, root) {\n" : "(function (" + c + ", data) {\n", 1 === t && (u += "function isArray(arr){return Object.prototype.toString.apply(arr) === '[object Array]';}\n", u += "function isFunction(func){return (typeof func === 'function');}\n", u += 'function c(val, ctx) {if (typeof val !== "undefined" && val !== null) {if (isFunction(val)) {return val.call(ctx);} else return val;} else return "";}\n', u += "root = root || ctx_1 || {};\n"), u += "var r = '';\n";
          var d;
          for (d = 0; d < a.length; d++) {
            var p = a[d];
            if ("plain" !== p.type) {
              var m, f;
              if ("variable" === p.type && (m = r(p.contextName, c), u += "r += c(" + m + ", " + c + ");"), "helper" === p.type)
                if (p.helperName in l.helpers) f = s(p.contextName, c), u += "r += (Template7.helpers." + p.helperName + ").call(" + c + ", " + (f && f + ", ") + "{hash:" + JSON.stringify(p.hash) + ", data: data || {}, fn: " + o(p, t + 1) + ", inverse: " + n(p, t + 1) + ", root: root});";
                else {
                  if (p.contextName.length > 0) throw new Error('Template7: Missing helper: "' + p.helperName + '"');
                  m = r(p.helperName, c), u += "if (" + m + ") {", u += "if (isArray(" + m + ")) {", u += "r += (Template7.helpers.each).call(" + c + ", " + m + ", {hash:" + JSON.stringify(p.hash) + ", data: data || {}, fn: " + o(p, t + 1) + ", inverse: " + n(p, t + 1) + ", root: root});", u += "}else {", u += "r += (Template7.helpers.with).call(" + c + ", " + m + ", {hash:" + JSON.stringify(p.hash) + ", data: data || {}, fn: " + o(p, t + 1) + ", inverse: " + n(p, t + 1) + ", root: root});", u += "}}"
                }
            } else u += "r +='" + p.content.replace(/\r/g, "\\r").replace(/\n/g, "\\n").replace(/'/g, "\\'") + "';"
          }
          return u += "\nreturn r;})", eval.call(window, u)
        }
        var l = this;
        l.template = e, l.compile = function(e) {
          return l.compiled || (l.compiled = a(e)), l.compiled
        }
      };
    a.prototype = {
      options: {},
      partials: {},
      helpers: {
        _partial: function(e, t) {
          var o = a.prototype.partials[e];
          if (!o || o && !o.template) return "";
          o.compiled || (o.compiled = new a(o.template).compile());
          var n = this;
          for (var i in t.hash) n[i] = t.hash[i];
          return o.compiled(n, t.data, t.root)
        },
        escape: function(e, t) {
          if ("string" != typeof e) throw new Error('Template7: Passed context to "escape" helper should be a string');
          return o(e)
        },
        "if": function(e, o) {
          return t(e) && (e = e.call(this)), e ? o.fn(this, o.data) : o.inverse(this, o.data)
        },
        unless: function(e, o) {
          return t(e) && (e = e.call(this)), e ? o.inverse(this, o.data) : o.fn(this, o.data)
        },
        each: function(o, n) {
          var i = "",
            r = 0;
          if (t(o) && (o = o.call(this)), e(o)) {
            for (n.hash.reverse && (o = o.reverse()), r = 0; r < o.length; r++) i += n.fn(o[r], {
              first: 0 === r,
              last: r === o.length - 1,
              index: r
            });
            n.hash.reverse && (o = o.reverse())
          } else
            for (var s in o) r++, i += n.fn(o[s], {
              key: s
            });
          return r > 0 ? i : n.inverse(this)
        },
        "with": function(e, o) {
          return t(e) && (e = e.call(this)), o.fn(e)
        },
        join: function(e, o) {
          return t(e) && (e = e.call(this)), e.join(o.hash.delimiter || o.hash.delimeter)
        },
        js: function(e, t) {
          var o;
          return o = e.indexOf("return") >= 0 ? "(function(){" + e + "})" : "(function(){return (" + e + ")})", eval.call(this, o).call(this)
        },
        js_compare: function(e, t) {
          var o;
          o = e.indexOf("return") >= 0 ? "(function(){" + e + "})" : "(function(){return (" + e + ")})";
          var n = eval.call(this, o).call(this);
          return n ? t.fn(this, t.data) : t.inverse(this, t.data)
        }
      }
    };
    var l = function(e, t) {
      if (2 === arguments.length) {
        var o = new a(e),
          n = o.compile()(t);
        return o = null, n
      }
      return new a(e)
    };
    return l.registerHelper = function(e, t) {
      a.prototype.helpers[e] = t
    }, l.unregisterHelper = function(e) {
      a.prototype.helpers[e] = void 0, delete a.prototype.helpers[e]
    }, l.registerPartial = function(e, t) {
      a.prototype.partials[e] = {
        template: t
      }
    }, l.unregisterPartial = function(e, t) {
      a.prototype.partials[e] && (a.prototype.partials[e] = void 0, delete a.prototype.partials[e])
    }, l.compile = function(e, t) {
      var o = new a(e, t);
      return o.compile()
    }, l.options = a.prototype.options, l.helpers = a.prototype.helpers, l.partials = a.prototype.partials, l
  }(),
  function(e, t) {
    "use strict";
    if ("function" != typeof e.createEvent) return !1;
    var o, n, i, r, s, a, l, c, u = function(e) {
        var t = e.toLowerCase(),
          o = "MS" + e;
        return navigator.msPointerEnabled ? o : t
      },
      d = {
        useJquery: !t.IGNORE_JQUERY && "undefined" != typeof jQuery,
        swipeThreshold: t.SWIPE_THRESHOLD || 100,
        tapThreshold: t.TAP_THRESHOLD || 150,
        dbltapThreshold: t.DBL_TAP_THRESHOLD || 200,
        longtapThreshold: t.LONG_TAP_THRESHOLD || 1e3,
        tapPrecision: t.TAP_PRECISION / 2 || 30,
        justTouchEvents: t.JUST_ON_TOUCH_DEVICES
      },
      p = !1,
      m = {
        touchstart: u("PointerDown") + " touchstart",
        touchend: u("PointerUp") + " touchend",
        touchmove: u("PointerMove") + " touchmove"
      },
      f = function(e, t, o) {
        for (var n = t.split(" "), i = n.length; i--;) e.addEventListener(n[i], o, !1)
      },
      h = function(e) {
        return e.targetTouches ? e.targetTouches[0] : e
      },
      y = function() {
        return (new Date).getTime()
      },
      g = function(t, i, r, s) {
        var a = e.createEvent("Event");
        if (a.originalEvent = r, s = s || {}, s.x = o, s.y = n, s.distance = s.distance, d.useJquery && (a = jQuery.Event(i, {
            originalEvent: r
          }), jQuery(t).trigger(a, s)), a.initEvent) {
          for (var l in s) a[l] = s[l];
          a.initEvent(i, !0, !0), t.dispatchEvent(a)
        }
        for (; t;) t["on" + i] && t["on" + i](a), t = t.parentNode
      },
      v = function(e) {
        if ("mousedown" !== e.type && (p = !0), "mousedown" !== e.type || !p) {
          var t = h(e);
          i = o = t.pageX, r = n = t.pageY, c = setTimeout(function() {
            g(e.target, "longtap", e), a = e.target
          }, d.longtapThreshold), s = y(), _++
        }
      },
      b = function(e) {
        if ("mouseup" === e.type && p) return void(p = !1);
        var t = [],
          u = y(),
          m = r - n,
          f = i - o;
        if (clearTimeout(l), clearTimeout(c), f <= -d.swipeThreshold && t.push("swiperight"), f >= d.swipeThreshold && t.push("swipeleft"), m <= -d.swipeThreshold && t.push("swipedown"), m >= d.swipeThreshold && t.push("swipeup"), t.length) {
          for (var h = 0; h < t.length; h++) {
            var v = t[h];
            g(e.target, v, e, {
              distance: {
                x: Math.abs(f),
                y: Math.abs(m)
              }
            })
          }
          _ = 0
        } else i >= o - d.tapPrecision && i <= o + d.tapPrecision && r >= n - d.tapPrecision && r <= n + d.tapPrecision && s + d.tapThreshold - u >= 0 && (g(e.target, _ >= 2 && a === e.target ? "dbltap" : "tap", e), a = e.target), l = setTimeout(function() {
          _ = 0
        }, d.dbltapThreshold)
      },
      w = function(e) {
        if ("mousemove" !== e.type || !p) {
          var t = h(e);
          o = t.pageX, n = t.pageY
        }
      },
      _ = 0;
    f(e, m.touchstart + (d.justTouchEvents ? "" : " mousedown"), v), f(e, m.touchend + (d.justTouchEvents ? "" : " mouseup"), b), f(e, m.touchmove + (d.justTouchEvents ? "" : " mousemove"), w), t.tocca = function(e) {
      for (var t in e) d[t] = e[t];
      return d
    }
  }(document, window);

  //lazyloaded
  !function(e,t){var r=t(e,e.document);e.lazySizes=r,"object"==typeof module&&module.exports&&(module.exports=r)}(window,function(e,t){"use strict";if(t.getElementsByClassName){var r,i,a=t.documentElement,n=e.Date,s=e.HTMLPictureElement,o="addEventListener",l="getAttribute",u=e[o],c=e.setTimeout,d=e.requestAnimationFrame||c,f=e.requestIdleCallback,g=/^picture$/i,p=["load","error","lazyincluded","_lazyloaded"],y={},z=Array.prototype.forEach,m=function(e,t){return y[t]||(y[t]=new RegExp("(\\s|^)"+t+"(\\s|$)")),y[t].test(e[l]("class")||"")&&y[t]},v=function(e,t){m(e,t)||e.setAttribute("class",(e[l]("class")||"").trim()+" "+t)},b=function(e,t){var r;(r=m(e,t))&&e.setAttribute("class",(e[l]("class")||"").replace(r," "))},A=function(e,t,r){var i=r?o:"removeEventListener";r&&A(e,t),p.forEach(function(r){e[i](r,t)})},h=function(e,i,a,n,s){var o=t.createEvent("CustomEvent");return a||(a={}),a.instance=r,o.initCustomEvent(i,!n,!s,a),e.dispatchEvent(o),o},E=function(t,r){var a;!s&&(a=e.picturefill||i.pf)?a({reevaluate:!0,elements:[t]}):r&&r.src&&(t.src=r.src)},C=function(e,t){return(getComputedStyle(e,null)||{})[t]},w=function(e,t,r){for(r=r||e.offsetWidth;r<i.minSize&&t&&!e._lazysizesWidth;)r=t.offsetWidth,t=t.parentNode;return r},_=function(){var e,r,i=[],a=[],n=i,s=function(){var t=n;for(n=i.length?a:i,e=!0,r=!1;t.length;)t.shift()();e=!1},o=function(i,a){e&&!a?i.apply(this,arguments):(n.push(i),r||(r=!0,(t.hidden?c:d)(s)))};return o._lsFlush=s,o}(),S=function(e,t){return t?function(){_(e)}:function(){var t=this,r=arguments;_(function(){e.apply(t,r)})}},x=function(e){var t,r=0,a=125,s=i.ricTimeout,o=function(){t=!1,r=n.now(),e()},l=f&&i.ricTimeout?function(){f(o,{timeout:s}),s!==i.ricTimeout&&(s=i.ricTimeout)}:S(function(){c(o)},!0);return function(e){var i;(e=e===!0)&&(s=33),t||(t=!0,i=a-(n.now()-r),i<0&&(i=0),e||i<9&&f?l():c(l,i))}},N=function(e){var t,r,i=99,a=function(){t=null,e()},s=function(){var e=n.now()-r;e<i?c(s,i-e):(f||a)(a)};return function(){r=n.now(),t||(t=c(s,i))}};!function(){var t,r={lazyClass:"lazyload",loadedClass:"lazyloaded",loadingClass:"lazyloading",preloadClass:"lazypreload",errorClass:"lazyerror",autosizesClass:"lazyautosizes",srcAttr:"data-src",srcsetAttr:"data-srcset",sizesAttr:"data-sizes",minSize:40,customMedia:{},init:!0,expFactor:1.5,hFac:.8,loadMode:2,loadHidden:!0,ricTimeout:300};i=e.lazySizesConfig||e.lazysizesConfig||{};for(t in r)t in i||(i[t]=r[t]);e.lazySizesConfig=i,c(function(){i.init&&M()})}();var P=function(){var s,d,f,p,y,w,P,M,T,O,R,F,j,$,k=/^img$/i,W=/^iframe$/i,B="onscroll"in e&&!/glebot/.test(navigator.userAgent),I=0,q=0,U=0,H=-1,X=function(e){U--,e&&e.target&&A(e.target,X),(!e||U<0||!e.target)&&(U=0)},D=function(e,r){var i,n=e,s="hidden"==C(t.body,"visibility")||"hidden"!=C(e,"visibility");for(M-=r,R+=r,T-=r,O+=r;s&&(n=n.offsetParent)&&n!=t.body&&n!=a;)s=(C(n,"opacity")||1)>0,s&&"visible"!=C(n,"overflow")&&(i=n.getBoundingClientRect(),s=O>i.left&&T<i.right&&R>i.top-1&&M<i.bottom+1);return s},J=function(){var e,n,o,u,c,f,g,y,z,m=r.elements;if((p=i.loadMode)&&U<8&&(e=m.length)){n=0,H++,null==j&&("expand"in i||(i.expand=a.clientHeight>500&&a.clientWidth>500?500:370),F=i.expand,j=F*i.expFactor),q<j&&U<1&&H>2&&p>2&&!t.hidden?(q=j,H=0):q=p>1&&H>1&&U<6?F:I;for(;n<e;n++)if(m[n]&&!m[n]._lazyRace)if(B)if((y=m[n][l]("data-expand"))&&(f=1*y)||(f=q),z!==f&&(w=innerWidth+f*$,P=innerHeight+f,g=f*-1,z=f),o=m[n].getBoundingClientRect(),(R=o.bottom)>=g&&(M=o.top)<=P&&(O=o.right)>=g*$&&(T=o.left)<=w&&(R||O||T||M)&&(i.loadHidden||"hidden"!=C(m[n],"visibility"))&&(d&&U<3&&!y&&(p<3||H<4)||D(m[n],f))){if(te(m[n]),c=!0,U>9)break}else!c&&d&&!u&&U<4&&H<4&&p>2&&(s[0]||i.preloadAfterLoad)&&(s[0]||!y&&(R||O||T||M||"auto"!=m[n][l](i.sizesAttr)))&&(u=s[0]||m[n]);else te(m[n]);u&&!c&&te(u)}},V=x(J),G=function(e){v(e.target,i.loadedClass),b(e.target,i.loadingClass),A(e.target,Q),h(e.target,"lazyloaded")},K=S(G),Q=function(e){K({target:e.target})},Y=function(e,t){try{e.contentWindow.location.replace(t)}catch(r){e.src=t}},Z=function(e){var t,r=e[l](i.srcsetAttr);(t=i.customMedia[e[l]("data-media")||e[l]("media")])&&e.setAttribute("media",t),r&&e.setAttribute("srcset",r)},ee=S(function(e,t,r,a,n){var s,o,u,d,p,y;(p=h(e,"lazybeforeunveil",t)).defaultPrevented||(a&&(r?v(e,i.autosizesClass):e.setAttribute("sizes",a)),o=e[l](i.srcsetAttr),s=e[l](i.srcAttr),n&&(u=e.parentNode,d=u&&g.test(u.nodeName||"")),y=t.firesLoad||"src"in e&&(o||s||d),p={target:e},y&&(A(e,X,!0),clearTimeout(f),f=c(X,2500),v(e,i.loadingClass),A(e,Q,!0)),d&&z.call(u.getElementsByTagName("source"),Z),o?e.setAttribute("srcset",o):s&&!d&&(W.test(e.nodeName)?Y(e,s):e.src=s),n&&(o||d)&&E(e,{src:s})),e._lazyRace&&delete e._lazyRace,b(e,i.lazyClass),_(function(){(!y||e.complete&&e.naturalWidth>1)&&(y?X(p):U--,G(p))},!0)}),te=function(e){var t,r=k.test(e.nodeName),a=r&&(e[l](i.sizesAttr)||e[l]("sizes")),n="auto"==a;(!n&&d||!r||!e[l]("src")&&!e.srcset||e.complete||m(e,i.errorClass)||!m(e,i.lazyClass))&&(t=h(e,"lazyunveilread").detail,n&&L.updateElem(e,!0,e.offsetWidth),e._lazyRace=!0,U++,ee(e,t,n,a,r))},re=function(){if(!d){if(n.now()-y<999)return void c(re,999);var e=N(function(){i.loadMode=3,V()});d=!0,i.loadMode=3,V(),u("scroll",function(){3==i.loadMode&&(i.loadMode=2),e()},!0)}};return{_:function(){y=n.now(),r.elements=t.getElementsByClassName(i.lazyClass),s=t.getElementsByClassName(i.lazyClass+" "+i.preloadClass),$=i.hFac,u("scroll",V,!0),u("resize",V,!0),e.MutationObserver?new MutationObserver(V).observe(a,{childList:!0,subtree:!0,attributes:!0}):(a[o]("DOMNodeInserted",V,!0),a[o]("DOMAttrModified",V,!0),setInterval(V,999)),u("hashchange",V,!0),["focus","mouseover","click","load","transitionend","animationend","webkitAnimationEnd"].forEach(function(e){t[o](e,V,!0)}),/d$|^c/.test(t.readyState)?re():(u("load",re),t[o]("DOMContentLoaded",V),c(re,2e4)),r.elements.length?(J(),_._lsFlush()):V()},checkElems:V,unveil:te}}(),L=function(){var e,r=S(function(e,t,r,i){var a,n,s;if(e._lazysizesWidth=i,i+="px",e.setAttribute("sizes",i),g.test(t.nodeName||""))for(a=t.getElementsByTagName("source"),n=0,s=a.length;n<s;n++)a[n].setAttribute("sizes",i);r.detail.dataAttr||E(e,r.detail)}),a=function(e,t,i){var a,n=e.parentNode;n&&(i=w(e,n,i),a=h(e,"lazybeforesizes",{width:i,dataAttr:!!t}),a.defaultPrevented||(i=a.detail.width,i&&i!==e._lazysizesWidth&&r(e,n,a,i)))},n=function(){var t,r=e.length;if(r)for(t=0;t<r;t++)a(e[t])},s=N(n);return{_:function(){e=t.getElementsByClassName(i.autosizesClass),u("resize",s)},checkElems:s,updateElem:a}}(),M=function(){M.i||(M.i=!0,L._(),P._())};return r={cfg:i,autoSizer:L,loader:P,init:M,uP:E,aC:v,rC:b,hC:m,fire:h,gW:w,rAF:_}}}),function(e,t){var r=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",r,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes"),require("../fix-ios-sizes/fix-ios-sizes")):e.lazySizes?r():e.addEventListener("lazyunveilread",r,!0)}(window,function(e,t,r){"use strict";var i,a=r&&r.cfg||e.lazySizesConfig,n=t.createElement("img"),s="sizes"in n&&"srcset"in n,o=/\s+\d+h/g,l=function(){var e=/\s+(\d+)(w|h)\s+(\d+)(w|h)/,r=Array.prototype.forEach;return function(i){var a=t.createElement("img"),n=function(t){var r,i=t.getAttribute(lazySizesConfig.srcsetAttr);i&&(i.match(e)&&(r="w"==RegExp.$2?RegExp.$1/RegExp.$3:RegExp.$3/RegExp.$1,r&&t.setAttribute("data-aspectratio",r)),t.setAttribute(lazySizesConfig.srcsetAttr,i.replace(o,"")))},s=function(e){var t=e.target.parentNode;t&&"PICTURE"==t.nodeName&&r.call(t.getElementsByTagName("source"),n),n(e.target)},l=function(){a.currentSrc&&t.removeEventListener("lazybeforeunveil",s)};i[1]&&(t.addEventListener("lazybeforeunveil",s),a.onload=l,a.onerror=l,a.srcset="data:,a 1w 1h",a.complete&&l())}}();if(a||(a={},e.lazySizesConfig=a),a.supportsType||(a.supportsType=function(e){return!e}),!e.picturefill&&!a.pf){if(e.HTMLPictureElement&&s)return t.msElementsFromPoint&&l(navigator.userAgent.match(/Edge\/(\d+)/)),void(a.pf=function(){});a.pf=function(t){var r,a;if(!e.picturefill)for(r=0,a=t.elements.length;r<a;r++)i(t.elements[r])},i=function(){var n=function(e,t){return e.w-t.w},l=/^\s*\d+\.*\d*px\s*$/,u=function(e){var t,r,i=e.length,a=e[i-1],n=0;for(n;n<i;n++)if(a=e[n],a.d=a.w/e.w,a.d>=e.d){!a.cached&&(t=e[n-1])&&t.d>e.d-.13*Math.pow(e.d,2.2)&&(r=Math.pow(t.d-.6,1.6),t.cached&&(t.d+=.15*r),t.d+(a.d-e.d)*r>e.d&&(a=t));break}return a},c=function(){var e,t=/(([^,\s].[^\s]+)\s+(\d+)w)/g,r=/\s/,i=function(t,r,i,a){e.push({c:r,u:i,w:1*a})};return function(a){return e=[],a=a.trim(),a.replace(o,"").replace(t,i),e.length||!a||r.test(a)||e.push({c:a,u:a,w:99}),e}}(),d=function(){d.init||(d.init=!0,addEventListener("resize",function(){var e,r=t.getElementsByClassName("lazymatchmedia"),a=function(){var e,t;for(e=0,t=r.length;e<t;e++)i(r[e])};return function(){clearTimeout(e),e=setTimeout(a,66)}}()))},f=function(t,i){var n,s=t.getAttribute("srcset")||t.getAttribute(a.srcsetAttr);!s&&i&&(s=t._lazypolyfill?t._lazypolyfill._set:t.getAttribute(a.srcAttr)||t.getAttribute("src")),t._lazypolyfill&&t._lazypolyfill._set==s||(n=c(s||""),i&&t.parentNode&&(n.isPicture="PICTURE"==t.parentNode.nodeName.toUpperCase(),n.isPicture&&e.matchMedia&&(r.aC(t,"lazymatchmedia"),d())),n._set=s,Object.defineProperty(t,"_lazypolyfill",{value:n,writable:!0}))},g=function(t){var i=e.devicePixelRatio||1,a=r.getX&&r.getX(t);return Math.min(a||i,2.5,i)},p=function(t){return e.matchMedia?(p=function(e){return!e||(matchMedia(e)||{}).matches})(t):!t},y=function(e){var t,i,s,o,c,d,y;if(o=e,f(o,!0),c=o._lazypolyfill,c.isPicture)for(i=0,t=e.parentNode.getElementsByTagName("source"),s=t.length;i<s;i++)if(a.supportsType(t[i].getAttribute("type"),e)&&p(t[i].getAttribute("media"))){o=t[i],f(o),c=o._lazypolyfill;break}return c.length>1?(y=o.getAttribute("sizes")||"",y=l.test(y)&&parseInt(y,10)||r.gW(e,e.parentNode),c.d=g(e),!c.src||!c.w||c.w<y?(c.w=y,d=u(c.sort(n)),c.src=d):d=c.src):d=c[0],d},z=function(e){if(!s||!e.parentNode||"PICTURE"==e.parentNode.nodeName.toUpperCase()){var t=y(e);t&&t.u&&e._lazypolyfill.cur!=t.u&&(e._lazypolyfill.cur=t.u,t.cached=!0,e.setAttribute(a.srcAttr,t.u),e.setAttribute("src",t.u))}};return z.parse=c,z}(),a.loadedClass&&a.loadingClass&&!function(){var e=[];['img[sizes$="px"][srcset].',"picture > img:not([srcset])."].forEach(function(t){e.push(t+a.loadedClass),e.push(t+a.loadingClass)}),a.pf({elements:t.querySelectorAll(e.join(", "))})}()}}),function(e,t){var r=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",r,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?r():e.addEventListener("lazyunveilread",r,!0)}(window,function(e,t,r){"use strict";if(e.addEventListener){var i,a=/^picture$/i,n=t.documentElement,s=function(){var e,t=/(([^,\s].[^\s]+)\s+(\d+)(w|h)(\s+(\d+)(w|h))?)/g,r=function(t,r,i,a,n,s,o,l){e.push({c:r,u:i,w:1*("w"==l?o:a)})};return function(i){return e=[],i.replace(t,r),e}}(),o=function(){var e=function(e,t){return e.w-t.w},t=function(t,i){var a={srcset:t.getAttribute(r.cfg.srcsetAttr)||""},n=s(a.srcset);return Object.defineProperty(t,i,{value:a,writable:!0}),a.cands=n,a.index=0,a.dirty=!1,n[0]&&n[0].w?(n.sort(e),a.cSrcset=[n[a.index].c]):(a.cSrcset=a.srcset?[a.srcset]:[],a.cands=[]),a};return function(e,r){var i,n,s,o;if(!e[r]&&(o=e.parentNode||{},e[r]=t(e,r),e[r].isImg=!0,a.test(o.nodeName||"")))for(e[r].picture=!0,i=o.getElementsByTagName("source"),n=0,s=i.length;n<s;n++)t(i[n],r).isImg=!1;return e[r]}}(),l={_lazyOptimumx:function(){var e=function(e,t,r){var i,a,n;return!e||!e.d||(n=r>.7?.6:.4,!(e.d>=r)&&(a=Math.pow(e.d-n,1.6)||.1,a<.1?a=.1:a>3&&(a=3),i=e.d+(t-r)*a,i<r))};return function(t,r,i){var a,n;for(a=0;a<t.cands.length;a++)if(n=t.cands[a],n.d=(n.w||1)/r,!(t.index>=a)){if(!(n.d<=i||e(t.cands[a-1],n.d,i)))break;t.cSrcset.push(n.c),t.index=a}}}()},u=function(){var e=function(e,t,r,i,a){var n,s=e[a];s&&(n=s.index,l[a](s,t,r),s.dirty&&n==s.index||(s.cSrcset.join(", "),e.setAttribute(i,s.cSrcset.join(", ")),s.dirty=!0))};return function(t,r,i,a,n){var s,o,l,u,c=t[n];if(c.width=r,c.picture&&(o=t.parentNode))for(s=o.getElementsByTagName("source"),u=0,l=s.length;u<l;u++)e(s[u],r,i,a,n);e(t,r,i,a,n)}}(),c=function(e){var t=e.getAttribute("data-optimumx")||e.getAttribute("data-maxdpr");return!t&&i.constrainPixelDensity&&(t="auto"),t&&(t="auto"==t?i.getOptimumX(e):parseFloat(t,10)),t},d=function(){r&&!r.getOptimumX&&(r.getX=c,r.pWS=s,n.removeEventListener("lazybeforeunveil",d))};n.addEventListener("lazybeforeunveil",d),setTimeout(d),i=r&&r.cfg||e.lazySizesConfig,i||(i={},e.lazySizesConfig=i),"function"!=typeof i.getOptimumX&&(i.getOptimumX=function(){var t=e.devicePixelRatio||1;return t>2.6?t*=.6:t>1.9?t*=.8:t-=.01,Math.min(Math.round(100*t)/100,2)}),e.devicePixelRatio&&addEventListener("lazybeforesizes",function(e){if(e.detail.instance==r){var t,a,n,s,l=e.target,d=e.detail,f=d.dataAttr;e.defaultPrevented||!(t=c(l))||t>=devicePixelRatio||(!f||!l._lazyOptimumx||d.reloaded||i.unloadedClass&&r.hC(l,i.unloadedClass)||(l._lazyOptimumx=null),a=o(l,"_lazyOptimumx"),n=d.width,n&&(a.width||0)<n&&(s=f?r.cfg.srcsetAttr:"srcset",r.rAF(function(){u(l,n,t,s,"_lazyOptimumx")})))}})}}),function(e,t){var r=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",r,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?r():e.addEventListener("lazyunveilread",r,!0)}(window,function(e,t,r){"use strict";if(e.addEventListener){var i=/\s+/g,a=/\s*\|\s+|\s+\|\s*/g,n=/^(.+?)(?:\s+\[\s*(.+?)\s*\])?$/,s=/\(|\)|'/,o={contain:1,cover:1},l=function(e){var t=r.gW(e,e.parentNode);return(!e._lazysizesWidth||t>e._lazysizesWidth)&&(e._lazysizesWidth=t),e._lazysizesWidth},u=function(e){var t;return t=(getComputedStyle(e)||{getPropertyValue:function(){}}).getPropertyValue("background-size"),!o[t]&&o[e.style.backgroundSize]&&(t=e.style.backgroundSize),t},c=function(e,r,s){var o=t.createElement("picture"),l=r.getAttribute(lazySizesConfig.sizesAttr),u=r.getAttribute("data-ratio"),c=r.getAttribute("data-optimumx");r._lazybgset&&r._lazybgset.parentNode==r&&r.removeChild(r._lazybgset),Object.defineProperty(s,"_lazybgset",{value:r,writable:!0}),Object.defineProperty(r,"_lazybgset",{value:o,writable:!0}),e=e.replace(i," ").split(a),o.style.display="none",s.className=lazySizesConfig.lazyClass,1!=e.length||l||(l="auto"),e.forEach(function(e){var r=t.createElement("source");l&&"auto"!=l&&r.setAttribute("sizes",l),e.match(n)&&(r.setAttribute(lazySizesConfig.srcsetAttr,RegExp.$1),RegExp.$2&&r.setAttribute("media",lazySizesConfig.customMedia[RegExp.$2]||RegExp.$2)),o.appendChild(r)}),l&&(s.setAttribute(lazySizesConfig.sizesAttr,l),r.removeAttribute(lazySizesConfig.sizesAttr),r.removeAttribute("sizes")),c&&s.setAttribute("data-optimumx",c),u&&s.setAttribute("data-ratio",u),o.appendChild(s),r.appendChild(o)},d=function(e){if(e.target._lazybgset){var t=e.target,i=t._lazybgset,a=t.currentSrc||t.src;a&&(i.style.backgroundImage="url("+(s.test(a)?JSON.stringify(a):a)+")"),t._lazybgsetLoading&&(r.fire(i,"_lazyloaded",{},!1,!0),delete t._lazybgsetLoading)}};addEventListener("lazybeforeunveil",function(e){var i,a,n;!e.defaultPrevented&&(i=e.target.getAttribute("data-bgset"))&&(n=e.target,a=t.createElement("img"),a.alt="",a._lazybgsetLoading=!0,e.detail.firesLoad=!0,c(i,n,a),setTimeout(function(){r.loader.unveil(a),r.rAF(function(){r.fire(a,"_lazyloaded",{},!0,!0),a.complete&&d({target:a})})}))}),t.addEventListener("load",d,!0),e.addEventListener("lazybeforesizes",function(e){if(e.detail.instance==r&&e.target._lazybgset&&e.detail.dataAttr){var t=e.target._lazybgset,i=u(t);o[i]&&(e.target._lazysizesParentFit=i,r.rAF(function(){e.target.setAttribute("data-parent-fit",i),e.target._lazysizesParentFit&&delete e.target._lazysizesParentFit}))}},!0),t.documentElement.addEventListener("lazybeforesizes",function(e){!e.defaultPrevented&&e.target._lazybgset&&e.detail.instance==r&&(e.detail.width=l(e.target._lazybgset))})}}),function(e,t){var r=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",r,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?r():e.addEventListener("lazyunveilread",r,!0)}(window,function(e,t,r){"use strict";function i(t,r){var i,a,n,s,o=e.getComputedStyle(t);a=t.parentNode,s={isPicture:!(!a||!f.test(a.nodeName||""))},n=function(e,r){var i=t.getAttribute("data-"+e);if(!i){var a=o.getPropertyValue("--ls-"+e);a&&(i=a.trim())}if(i){if("true"==i)i=!0;else if("false"==i)i=!1;else if(d.test(i))i=parseFloat(i);else if("function"==typeof u[e])i=u[e](t,i);else if(z.test(i))try{i=JSON.parse(i)}catch(n){}s[e]=i}else e in u&&"function"!=typeof u[e]?s[e]=u[e]:r&&"function"==typeof u[e]&&(s[e]=u[e](t,i))};for(i in u)n(i);return r.replace(y,function(e,t){t in s||n(t,!0)}),s}function a(e,t){var r=[],i=function(e,r){return c[typeof t[r]]?t[r]:e};return r.srcset=[],t.absUrl&&(v.setAttribute("href",e),e=v.href),e=((t.prefix||"")+e+(t.postfix||"")).replace(y,i),t.widths.forEach(function(i){var a=t.widthmap[i]||i,n={u:e.replace(g,a).replace(p,t.ratio?Math.round(i*t.ratio):""),w:i};r.push(n),r.srcset.push(n.c=n.u+" "+i+"w")}),r}function n(e,r,i){var n=0,s=0,o=i;if(e){if("container"===r.ratio){for(n=o.scrollWidth,s=o.scrollHeight;!(n&&s||o===t);)o=o.parentNode,n=o.scrollWidth,s=o.scrollHeight;n&&s&&(r.ratio=s/n)}e=a(e,r),e.isPicture=r.isPicture,A&&"IMG"==i.nodeName.toUpperCase()?i.removeAttribute(l.srcsetAttr):i.setAttribute(l.srcsetAttr,e.srcset.join(", ")),Object.defineProperty(i,"_lazyrias",{value:e,writable:!0})}}function s(e,t){var a=i(e,t);return u.modifyOptions.call(e,{target:e,details:a,detail:a}),r.fire(e,"lazyriasmodifyoptions",a),a}function o(e){return e.getAttribute(e.getAttribute("data-srcattr")||u.srcAttr)||e.getAttribute(l.srcsetAttr)||e.getAttribute(l.srcAttr)||e.getAttribute("data-pfsrcset")||""}var l,u,c={string:1,number:1},d=/^\-*\+*\d+\.*\d*$/,f=/^picture$/i,g=/\s*\{\s*width\s*\}\s*/i,p=/\s*\{\s*height\s*\}\s*/i,y=/\s*\{\s*([a-z0-9]+)\s*\}\s*/gi,z=/^\[.*\]|\{.*\}$/,m=/^(?:auto|\d+(px)?)$/,v=t.createElement("a"),b=t.createElement("img"),A="srcset"in b&&!("sizes"in b),h=!!e.HTMLPictureElement&&!A;!function(){var t,i=function(){},a={prefix:"",postfix:"",srcAttr:"data-src",absUrl:!1,modifyOptions:i,widthmap:{},ratio:!1};l=r&&r.cfg||e.lazySizesConfig,l||(l={},e.lazySizesConfig=l),l.supportsType||(l.supportsType=function(e){return!e}),l.rias||(l.rias={}),u=l.rias,"widths"in u||(u.widths=[],function(e){for(var t,r=0;!t||t<3e3;)r+=5,r>30&&(r+=1),t=36*r,e.push(t)}(u.widths));for(t in a)t in u||(u[t]=a[t])}(),addEventListener("lazybeforesizes",function(e){if(e.detail.instance==r){var t,i,a,c,d,f,p,y,z,v,b,A,C;if(t=e.target,e.detail.dataAttr&&!e.defaultPrevented&&!u.disabled&&(z=t.getAttribute(l.sizesAttr)||t.getAttribute("sizes"))&&m.test(z)){if(i=o(t),a=s(t,i),b=g.test(a.prefix)||g.test(a.postfix),a.isPicture&&(c=t.parentNode))for(d=c.getElementsByTagName("source"),f=0,p=d.length;f<p;f++)(b||g.test(y=o(d[f])))&&(n(y,a,d[f]),A=!0);b||g.test(i)?(n(i,a,t),A=!0):A&&(C=[],C.srcset=[],C.isPicture=!0,Object.defineProperty(t,"_lazyrias",{value:C,writable:!0})),A&&(h?t.removeAttribute(l.srcAttr):"auto"!=z&&(v={width:parseInt(z,10)},E({target:t,detail:v})))}}},!0);var E=function(){var i=function(e,t){return e.w-t.w},a=function(e){var t,r,i=e.length,a=e[i-1],n=0;for(n;n<i;n++)if(a=e[n],a.d=a.w/e.w,a.d>=e.d){!a.cached&&(t=e[n-1])&&t.d>e.d-.13*Math.pow(e.d,2.2)&&(r=Math.pow(t.d-.6,1.6),t.cached&&(t.d+=.15*r),t.d+(a.d-e.d)*r>e.d&&(a=t));break}return a},n=function(e,t){var i;return!e._lazyrias&&r.pWS&&(i=r.pWS(e.getAttribute(l.srcsetAttr||""))).length&&(Object.defineProperty(e,"_lazyrias",{value:i,writable:!0}),t&&e.parentNode&&(i.isPicture="PICTURE"==e.parentNode.nodeName.toUpperCase())),e._lazyrias},s=function(t){var i=e.devicePixelRatio||1,a=r.getX&&r.getX(t);return Math.min(a||i,2.4,i)},o=function(t,r){var o,l,u,c,d,f;if(d=t._lazyrias,d.isPicture&&e.matchMedia)for(l=0,o=t.parentNode.getElementsByTagName("source"),u=o.length;l<u;l++)if(n(o[l])&&!o[l].getAttribute("type")&&(!(c=o[l].getAttribute("media"))||(matchMedia(c)||{}).matches)){d=o[l]._lazyrias;break}return(!d.w||d.w<r)&&(d.w=r,d.d=s(t),f=a(d.sort(i))),f},u=function(i){if(i.detail.instance==r){var a,s=i.target;return!A&&(e.respimage||e.picturefill||lazySizesConfig.pf)?void t.removeEventListener("lazybeforesizes",u):void(("_lazyrias"in s||i.detail.dataAttr&&n(s,!0))&&(a=o(s,i.detail.width),a&&a.u&&s._lazyrias.cur!=a.u&&(s._lazyrias.cur=a.u,a.cached=!0,r.rAF(function(){s.setAttribute(l.srcAttr,a.u),s.setAttribute("src",a.u)}))))}};return h?u=function(){}:addEventListener("lazybeforesizes",u),u}()}),function(e,t){var r=function(){t(e.lazySizes),e.removeEventListener("lazyunveilread",r,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?r():e.addEventListener("lazyunveilread",r,!0)}(window,function(e,t,r){"use strict";function i(e,r){if(!s[e]){var i=t.createElement(r?"link":"script"),a=t.getElementsByTagName("script")[0];r?(i.rel="stylesheet",i.href=e):i.src=e,s[e]=!0,s[i.src||i.href]=!0,a.parentNode.insertBefore(i,a)}}var a,n,s={};t.addEventListener&&(n=/\(|\)|\s|'/,a=function(e,r){var i=t.createElement("img");i.onload=function(){i.onload=null,i.onerror=null,i=null,r()},i.onerror=i.onload,i.src=e,i&&i.complete&&i.onload&&i.onload()},addEventListener("lazybeforeunveil",function(e){if(e.detail.instance==r){var t,s,o,l;e.defaultPrevented||("none"==e.target.preload&&(e.target.preload="auto"),t=e.target.getAttribute("data-link"),t&&i(t,!0),t=e.target.getAttribute("data-script"),t&&i(t),t=e.target.getAttribute("data-require"),t&&(r.cfg.requireJs?r.cfg.requireJs([t]):i(t)),o=e.target.getAttribute("data-bg"),o&&(e.detail.firesLoad=!0,s=function(){e.target.style.backgroundImage="url("+(n.test(o)?JSON.stringify(o):o)+")",e.detail.firesLoad=!1,r.fire(e.target,"_lazyloaded",{},!0,!0)},a(o,s)),l=e.target.getAttribute("data-poster"),l&&(e.detail.firesLoad=!0,s=function(){e.target.poster=l,e.detail.firesLoad=!1,r.fire(e.target,"_lazyloaded",{},!0,!0)},a(l,s)))}},!1))}),function(e,t){var r=function(i){t(e.lazySizes,i),e.removeEventListener("lazyunveilread",r,!0)};t=t.bind(null,e,e.document),"object"==typeof module&&module.exports?t(require("lazysizes")):e.lazySizes?r():e.addEventListener("lazyunveilread",r,!0)}(window,function(e,t,r,i){"use strict";function a(e){var t=getComputedStyle(e,null)||{},r=t.fontFamily||"",i=r.match(u)||"",a=i&&r.match(c)||"";return a&&(a=a[1]),{fit:i&&i[1]||"",position:g[a]||a||"center"}}function n(e,t){var i,a,n=r.cfg,s=e.cloneNode(!1),o=s.style,l=function(){var t=e.currentSrc||e.src;t&&a!==t&&(a=t,o.backgroundImage="url("+(f.test(t)?JSON.stringify(t):t)+")",i||(i=!0,r.rC(s,n.loadingClass),r.aC(s,n.loadedClass)))},u=function(){r.rAF(l)};e._lazysizesParentFit=t.fit,e.addEventListener("lazyloaded",u,!0),e.addEventListener("load",u,!0),s.addEventListener("load",function(){var e=s.currentSrc||s.src;e&&e!=d&&(s.src=d,s.srcset="")}),r.rAF(function(){var i=e,a=e.parentNode;"PICTURE"==a.nodeName.toUpperCase()&&(i=a,a=a.parentNode),r.rC(s,n.loadedClass),r.rC(s,n.lazyClass),r.aC(s,n.loadingClass),r.aC(s,n.objectFitClass||"lazysizes-display-clone"),s.getAttribute(n.srcsetAttr)&&s.setAttribute(n.srcsetAttr,""),s.getAttribute(n.srcAttr)&&s.setAttribute(n.srcAttr,""),s.src=d,s.srcset="",o.backgroundRepeat="no-repeat",o.backgroundPosition=t.position,o.backgroundSize=t.fit,i.style.display="none",e.setAttribute("data-parent-fit",t.fit),e.setAttribute("data-parent-container","prev"),a.insertBefore(s,i),e._lazysizesParentFit&&delete e._lazysizesParentFit,e.complete&&l()})}var s=t.createElement("a").style,o="objectFit"in s,l=o&&"objectPosition"in s,u=/object-fit["']*\s*:\s*["']*(contain|cover)/,c=/object-position["']*\s*:\s*["']*(.+?)(?=($|,|'|"|;))/,d="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==",f=/\(|\)|'/,g={center:"center","50% 50%":"center"};if(!o||!l){var p=function(e){if(e.detail.instance==r){var t=e.target,i=a(t);!i.fit||o&&"center"==i.position||n(t,i)}};e.addEventListener("lazyunveilread",p,!0),i&&i.detail&&p(i)}});
  //ekko-lightbox
  +function(a){"use strict";function b(a,b){if(!(a instanceof b))throw new TypeError("Cannot call a class as a function")}var c=function(){function a(a,b){for(var c=0;c<b.length;c++){var d=b[c];d.enumerable=d.enumerable||!1,d.configurable=!0,"value"in d&&(d.writable=!0),Object.defineProperty(a,d.key,d)}}return function(b,c,d){return c&&a(b.prototype,c),d&&a(b,d),b}}();(function(a){var d="ekkoLightbox",e=a.fn[d],f={title:"",footer:"",maxWidth:9999,maxHeight:9999,showArrows:!0,wrapping:!0,type:null,alwaysShowClose:!1,loadingMessage:'<div class="ekko-lightbox-loader"><div><div></div><div></div></div></div>',leftArrow:"<span>&#10094;</span>",rightArrow:"<span>&#10095;</span>",strings:{close:"Close",fail:"Failed to load image:",type:"Could not detect remote target type. Force the type using data-type"},doc:document,onShow:function(){},onShown:function(){},onHide:function(){},onHidden:function(){},onNavigate:function(){},onContentLoaded:function(){}},g=function(){function d(c,e){var g=this;b(this,d),this._config=a.extend({},f,e),this._$modalArrows=null,this._galleryIndex=0,this._galleryName=null,this._padding=null,this._border=null,this._titleIsShown=!1,this._footerIsShown=!1,this._wantedWidth=0,this._wantedHeight=0,this._touchstartX=0,this._touchendX=0,this._modalId="ekkoLightbox-"+Math.floor(1e3*Math.random()+1),this._$element=c instanceof jQuery?c:a(c),this._isBootstrap3=3==a.fn.modal.Constructor.VERSION[0];var h='<h4 class="modal-title">'+(this._config.title||"&nbsp;")+"</h4>",i='<button type="button" class="close" data-dismiss="modal" aria-label="'+this._config.strings.close+'"><span aria-hidden="true">&times;</span></button>',j='<div class="modal-header'+(this._config.title||this._config.alwaysShowClose?"":" hide")+'">'+(this._isBootstrap3?i+h:h+i)+"</div>",k='<div class="modal-footer'+(this._config.footer?"":" hide")+'">'+(this._config.footer||"&nbsp;")+"</div>",l='<div class="modal-body"><div class="ekko-lightbox-container"><div class="ekko-lightbox-item fade in show"></div><div class="ekko-lightbox-item fade"></div></div></div>',m='<div class="modal-dialog" role="document"><div class="modal-content">'+j+l+k+"</div></div>";a(this._config.doc.body).append('<div id="'+this._modalId+'" class="ekko-lightbox modal fade" tabindex="-1" tabindex="-1" role="dialog" aria-hidden="true">'+m+"</div>"),this._$modal=a("#"+this._modalId,this._config.doc),this._$modalDialog=this._$modal.find(".modal-dialog").first(),this._$modalContent=this._$modal.find(".modal-content").first(),this._$modalBody=this._$modal.find(".modal-body").first(),this._$modalHeader=this._$modal.find(".modal-header").first(),this._$modalFooter=this._$modal.find(".modal-footer").first(),this._$lightboxContainer=this._$modalBody.find(".ekko-lightbox-container").first(),this._$lightboxBodyOne=this._$lightboxContainer.find("> div:first-child").first(),this._$lightboxBodyTwo=this._$lightboxContainer.find("> div:last-child").first(),this._border=this._calculateBorders(),this._padding=this._calculatePadding(),this._galleryName=this._$element.data("gallery"),this._galleryName&&(this._$galleryItems=a(document.body).find('*[data-gallery="'+this._galleryName+'"]'),this._galleryIndex=this._$galleryItems.index(this._$element),a(document).on("keydown.ekkoLightbox",this._navigationalBinder.bind(this)),this._config.showArrows&&this._$galleryItems.length>1&&(this._$lightboxContainer.append('<div class="ekko-lightbox-nav-overlay"><a href="#">'+this._config.leftArrow+'</a><a href="#">'+this._config.rightArrow+"</a></div>"),this._$modalArrows=this._$lightboxContainer.find("div.ekko-lightbox-nav-overlay").first(),this._$lightboxContainer.on("click","a:first-child",function(a){return a.preventDefault(),g.navigateLeft()}),this._$lightboxContainer.on("click","a:last-child",function(a){return a.preventDefault(),g.navigateRight()}),this.updateNavigation())),this._$modal.on("show.bs.modal",this._config.onShow.bind(this)).on("shown.bs.modal",function(){return g._toggleLoading(!0),g._handle(),g._config.onShown.call(g)}).on("hide.bs.modal",this._config.onHide.bind(this)).on("hidden.bs.modal",function(){return g._galleryName&&(a(document).off("keydown.ekkoLightbox"),a(window).off("resize.ekkoLightbox")),g._$modal.remove(),g._config.onHidden.call(g)}).modal(this._config),a(window).on("resize.ekkoLightbox",function(){g._resize(g._wantedWidth,g._wantedHeight)}),this._$lightboxContainer.on("touchstart",function(){g._touchstartX=event.changedTouches[0].screenX}).on("touchend",function(){g._touchendX=event.changedTouches[0].screenX,g._swipeGesure()})}return c(d,null,[{key:"Default",get:function(){return f}}]),c(d,[{key:"element",value:function(){return this._$element}},{key:"modal",value:function(){return this._$modal}},{key:"navigateTo",value:function(b){return b<0||b>this._$galleryItems.length-1?this:(this._galleryIndex=b,this.updateNavigation(),this._$element=a(this._$galleryItems.get(this._galleryIndex)),void this._handle())}},{key:"navigateLeft",value:function(){if(this._$galleryItems&&1!==this._$galleryItems.length){if(0===this._galleryIndex){if(!this._config.wrapping)return;this._galleryIndex=this._$galleryItems.length-1}else this._galleryIndex--;return this._config.onNavigate.call(this,"left",this._galleryIndex),this.navigateTo(this._galleryIndex)}}},{key:"navigateRight",value:function(){if(this._$galleryItems&&1!==this._$galleryItems.length){if(this._galleryIndex===this._$galleryItems.length-1){if(!this._config.wrapping)return;this._galleryIndex=0}else this._galleryIndex++;return this._config.onNavigate.call(this,"right",this._galleryIndex),this.navigateTo(this._galleryIndex)}}},{key:"updateNavigation",value:function(){if(!this._config.wrapping){var a=this._$lightboxContainer.find("div.ekko-lightbox-nav-overlay");0===this._galleryIndex?a.find("a:first-child").addClass("disabled"):a.find("a:first-child").removeClass("disabled"),this._galleryIndex===this._$galleryItems.length-1?a.find("a:last-child").addClass("disabled"):a.find("a:last-child").removeClass("disabled")}}},{key:"close",value:function(){return this._$modal.modal("hide")}},{key:"_navigationalBinder",value:function(a){return a=a||window.event,39===a.keyCode?this.navigateRight():37===a.keyCode?this.navigateLeft():void 0}},{key:"_detectRemoteType",value:function(a,b){return b=b||!1,!b&&this._isImage(a)&&(b="image"),!b&&this._getYoutubeId(a)&&(b="youtube"),!b&&this._getVimeoId(a)&&(b="vimeo"),!b&&this._getInstagramId(a)&&(b="instagram"),("audio"==b||"video"==b||!b&&this._isMedia(a))&&(b="media"),(!b||["image","youtube","vimeo","instagram","media","url"].indexOf(b)<0)&&(b="url"),b}},{key:"_getRemoteContentType",value:function(b){var c=a.ajax({type:"HEAD",url:b,async:!1}),d=c.getResponseHeader("Content-Type");return d}},{key:"_isImage",value:function(a){return a&&a.match(/(^data:image\/.*,)|(\.(jp(e|g|eg)|gif|png|bmp|webp|svg)((\?|#).*)?$)/i)}},{key:"_isMedia",value:function(a){return a&&a.match(/(\.(mp3|mp4|ogg|webm|wav)((\?|#).*)?$)/i)}},{key:"_containerToUse",value:function(){var a=this,b=this._$lightboxBodyTwo,c=this._$lightboxBodyOne;return this._$lightboxBodyTwo.hasClass("in")&&(b=this._$lightboxBodyOne,c=this._$lightboxBodyTwo),c.removeClass("in show"),setTimeout(function(){a._$lightboxBodyTwo.hasClass("in")||a._$lightboxBodyTwo.empty(),a._$lightboxBodyOne.hasClass("in")||a._$lightboxBodyOne.empty()},500),b.addClass("in show"),b}},{key:"_handle",value:function(){var a=this._containerToUse();this._updateTitleAndFooter();var b=this._$element.attr("data-remote")||this._$element.attr("href"),c=this._detectRemoteType(b,this._$element.attr("data-type")||!1);if(["image","youtube","vimeo","instagram","media","url"].indexOf(c)<0)return this._error(this._config.strings.type);switch(c){case"image":this._preloadImage(b,a),this._preloadImageByIndex(this._galleryIndex,3);break;case"youtube":this._showYoutubeVideo(b,a);break;case"vimeo":this._showVimeoVideo(this._getVimeoId(b),a);break;case"instagram":this._showInstagramVideo(this._getInstagramId(b),a);break;case"media":this._showHtml5Media(b,a);break;default:this._loadRemoteContent(b,a)}return this}},{key:"_getYoutubeId",value:function(a){if(!a)return!1;var b=a.match(/^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|\&v=)([^#\&\?]*).*/);return!(!b||11!==b[2].length)&&b[2]}},{key:"_getVimeoId",value:function(a){return!!(a&&a.indexOf("vimeo")>0)&&a}},{key:"_getInstagramId",value:function(a){return!!(a&&a.indexOf("instagram")>0)&&a}},{key:"_toggleLoading",value:function(b){return b=b||!1,b?(this._$modalDialog.css("display","none"),this._$modal.removeClass("in show"),a(".modal-backdrop").append(this._config.loadingMessage)):(this._$modalDialog.css("display","block"),this._$modal.addClass("in show"),a(".modal-backdrop").find(".ekko-lightbox-loader").remove()),this}},{key:"_calculateBorders",value:function(){return{top:this._totalCssByAttribute("border-top-width"),right:this._totalCssByAttribute("border-right-width"),bottom:this._totalCssByAttribute("border-bottom-width"),left:this._totalCssByAttribute("border-left-width")}}},{key:"_calculatePadding",value:function(){return{top:this._totalCssByAttribute("padding-top"),right:this._totalCssByAttribute("padding-right"),bottom:this._totalCssByAttribute("padding-bottom"),left:this._totalCssByAttribute("padding-left")}}},{key:"_totalCssByAttribute",value:function(a){return parseInt(this._$modalDialog.css(a),10)+parseInt(this._$modalContent.css(a),10)+parseInt(this._$modalBody.css(a),10)}},{key:"_updateTitleAndFooter",value:function(){var a=this._$element.data("title")||"",b=this._$element.data("footer")||"";return this._titleIsShown=!1,a||this._config.alwaysShowClose?(this._titleIsShown=!0,this._$modalHeader.css("display","").find(".modal-title").html(a||"&nbsp;")):this._$modalHeader.css("display","none"),this._footerIsShown=!1,b?(this._footerIsShown=!0,this._$modalFooter.css("display","").html(b)):this._$modalFooter.css("display","none"),this}},{key:"_showYoutubeVideo",value:function(a,b){var c=this._getYoutubeId(a),d=a.indexOf("&")>0?a.substr(a.indexOf("&")):"",e=this._$element.data("width")||560,f=this._$element.data("height")||e/(560/315);return this._showVideoIframe("//www.youtube.com/embed/"+c+"?badge=0&autoplay=1&html5=1"+d,e,f,b)}},{key:"_showVimeoVideo",value:function(a,b){var c=this._$element.data("width")||500,d=this._$element.data("height")||c/(560/315);return this._showVideoIframe(a+"?autoplay=1",c,d,b)}},{key:"_showInstagramVideo",value:function(a,b){var c=this._$element.data("width")||612,d=c+80;return a="/"!==a.substr(-1)?a+"/":a,b.html('<iframe width="'+c+'" height="'+d+'" src="'+a+'embed/" frameborder="0" allowfullscreen></iframe>'),this._resize(c,d),this._config.onContentLoaded.call(this),this._$modalArrows&&this._$modalArrows.css("display","none"),this._toggleLoading(!1),this}},{key:"_showVideoIframe",value:function(a,b,c,d){return c=c||b,d.html('<div class="embed-responsive embed-responsive-16by9"><iframe width="'+b+'" height="'+c+'" src="'+a+'" frameborder="0" allowfullscreen class="embed-responsive-item"></iframe></div>'),this._resize(b,c),this._config.onContentLoaded.call(this),this._$modalArrows&&this._$modalArrows.css("display","none"),this._toggleLoading(!1),this}},{key:"_showHtml5Media",value:function(a,b){var c=this._getRemoteContentType(a);if(!c)return this._error(this._config.strings.type);var d="";d=c.indexOf("audio")>0?"audio":"video";var e=this._$element.data("width")||560,f=this._$element.data("height")||e/(560/315);return b.html('<div class="embed-responsive embed-responsive-16by9"><'+d+' width="'+e+'" height="'+f+'" preload="auto" autoplay controls class="embed-responsive-item"><source src="'+a+'" type="'+c+'">'+this._config.strings.type+"</"+d+"></div>"),this._resize(e,f),this._config.onContentLoaded.call(this),this._$modalArrows&&this._$modalArrows.css("display","none"),this._toggleLoading(!1),this}},{key:"_loadRemoteContent",value:function(b,c){var d=this,e=this._$element.data("width")||560,f=this._$element.data("height")||560,g=this._$element.data("disableExternalCheck")||!1;return this._toggleLoading(!1),g||this._isExternal(b)?(c.html('<iframe src="'+b+'" frameborder="0" allowfullscreen></iframe>'),this._config.onContentLoaded.call(this)):c.load(b,a.proxy(function(){return d._$element.trigger("loaded.bs.modal")})),this._$modalArrows&&this._$modalArrows.css("display","none"),this._resize(e,f),this}},{key:"_isExternal",value:function(a){var b=a.match(/^([^:\/?#]+:)?(?:\/\/([^\/?#]*))?([^?#]+)?(\?[^#]*)?(#.*)?/);return"string"==typeof b[1]&&b[1].length>0&&b[1].toLowerCase()!==location.protocol||"string"==typeof b[2]&&b[2].length>0&&b[2].replace(new RegExp(":("+{"http:":80,"https:":443}[location.protocol]+")?$"),"")!==location.host}},{key:"_error",value:function(a){return console.error(a),this._containerToUse().html(a),this._resize(300,300),this}},{key:"_preloadImageByIndex",value:function(b,c){if(this._$galleryItems){var d=a(this._$galleryItems.get(b),!1);if("undefined"!=typeof d){var e=d.attr("data-remote")||d.attr("href");return("image"===d.attr("data-type")||this._isImage(e))&&this._preloadImage(e,!1),c>0?this._preloadImageByIndex(b+1,c-1):void 0}}}},{key:"_preloadImage",value:function(b,c){var d=this;c=c||!1;var e=new Image;return c&&!function(){var f=setTimeout(function(){c.append(d._config.loadingMessage)},200);e.onload=function(){f&&clearTimeout(f),f=null;var b=a("<img />");return b.attr("src",e.src),b.addClass("img-fluid"),b.css("width","100%"),c.html(b),d._$modalArrows&&d._$modalArrows.css("display",""),d._resize(e.width,e.height),d._toggleLoading(!1),d._config.onContentLoaded.call(d)},e.onerror=function(){return d._toggleLoading(!1),d._error(d._config.strings.fail+("  "+b))}}(),e.src=b,e}},{key:"_swipeGesure",value:function(){return this._touchendX<this._touchstartX?this.navigateRight():this._touchendX>this._touchstartX?this.navigateLeft():void 0}},{key:"_resize",value:function(b,c){c=c||b,this._wantedWidth=b,this._wantedHeight=c;var d=b/c,e=this._padding.left+this._padding.right+this._border.left+this._border.right,f=this._config.doc.body.clientWidth>575?20:0,g=this._config.doc.body.clientWidth>575?0:20,h=Math.min(b+e,this._config.doc.body.clientWidth-f,this._config.maxWidth);b+e>h?(c=(h-e-g)/d,b=h):b+=e;var i=0,j=0;this._footerIsShown&&(j=this._$modalFooter.outerHeight(!0)||55),this._titleIsShown&&(i=this._$modalHeader.outerHeight(!0)||67);var k=this._padding.top+this._padding.bottom+this._border.bottom+this._border.top,l=parseFloat(this._$modalDialog.css("margin-top"))+parseFloat(this._$modalDialog.css("margin-bottom")),m=Math.min(c,a(window).height()-k-l-i-j,this._config.maxHeight-k-i-j);c>m&&(b=Math.ceil(m*d)+e),this._$lightboxContainer.css("height",m),this._$modalDialog.css("flex",1).css("maxWidth",b);var n=this._$modal.data("bs.modal");if(n)try{n._handleUpdate()}catch(o){n.handleUpdate()}return this}}],[{key:"_jQueryInterface",value:function(b){var c=this;return b=b||{},this.each(function(){var e=a(c),f=a.extend({},d.Default,e.data(),"object"==typeof b&&b);new d(c,f)})}}]),d}();return a.fn[d]=g._jQueryInterface,a.fn[d].Constructor=g,a.fn[d].noConflict=function(){return a.fn[d]=e,g._jQueryInterface},g})(jQuery)}(jQuery);
  //# sourceMappingURL=ekko-lightbox.min.js.map
